/* Mexicada global reviews - review wall + trust-banner modal */
(function () {
  'use strict';

  // Guard against double-execution: this script is loaded globally (header)
  // and also by the global-reviews section on pages that include it. Running
  // twice would double-bind the document click handlers.
  if (window.__mexicadaGlobalReviewsInit) return;
  window.__mexicadaGlobalReviewsInit = true;

  var SECTION_SELECTOR = '[data-mexicada-global-reviews]';
  var TRUST_BANNER_SELECTOR = '.mx-trust-banner';
  var EXTRA_REVIEW_MODAL_TRIGGER_SELECTOR = '.atc-review, h2.site-footer-block-title, [data-mgr-product-review-summary-trigger], .mexicada-product-review-summary';
  var REVIEW_MODAL_TRIGGER_SELECTOR = TRUST_BANNER_SELECTOR + ', ' + EXTRA_REVIEW_MODAL_TRIGGER_SELECTOR;
  var ATC_REVIEW_NAV_SELECTOR = '.atc-review-nav, .atc-review-btn, #atcReviewPrev, #atcReviewNext';
  var MODAL_ID = 'mexicada-global-reviews-modal';
  var initializedSections = new WeakSet();
  var modalElement = null;
  var modalLoader = null;
  var detailModalElement = null;
  var lastFocusedElement = null;
  var lastDetailFocusedElement = null;
  var reviewDataByCard = new WeakMap();

  var reviewMasonryGrids = new WeakMap();
  var reviewMasonryResizeTimer = null;
  var currentDetailImages = [];
  var currentDetailImageIndex = 0;
  var detailSwipeState = null;
  var detailSlideAnimationTimer = null;
  var detailSuppressClickUntil = 0;
  var detailTrackRenderedSignature = '';
  var cloudflareStreamScripts = {};


  function isIOSLikeDevice() {
    var ua = window.navigator && window.navigator.userAgent ? window.navigator.userAgent : '';
    var platform = window.navigator && window.navigator.platform ? window.navigator.platform : '';
    var hasTouch = window.navigator && window.navigator.maxTouchPoints && window.navigator.maxTouchPoints > 1;
    return /iPad|iPhone|iPod/.test(ua) || (platform === 'MacIntel' && hasTouch);
  }

  function getFirstFrameVideoUrl(url) {
    if (!url) return '';
    var value = String(url);
    if (value.indexOf('#t=') !== -1 || value.indexOf('#t,') !== -1) return value;
    var hashIndex = value.indexOf('#');
    if (hashIndex !== -1) value = value.slice(0, hashIndex);
    return value + '#t=0.001';
  }

  function primeIOSVideoThumbnail(video, rawUrl, done) {
    if (!video || !rawUrl || !isIOSLikeDevice()) return false;

    var released = false;
    var release = function () {
      if (released) return;
      released = true;
      if (video.classList) video.classList.remove('mgr-card__video-preview--ios-loading');
      if (typeof done === 'function') done();
    };

    var seekToFirstFrame = function () {
      try {
        if (video.readyState >= 1 && Math.abs((video.currentTime || 0) - 0.001) > 0.01) {
          video.currentTime = 0.001;
        }
      } catch (e) {}
    };

    if (video.classList) video.classList.add('mgr-card__video-preview--ios-loading');
    video.preload = 'auto';
    video.setAttribute('preload', 'auto');
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');

    video.addEventListener('loadedmetadata', seekToFirstFrame, { once: true });
    video.addEventListener('loadeddata', release, { once: true });
    video.addEventListener('canplay', release, { once: true });
    video.addEventListener('seeked', release, { once: true });
    video.addEventListener('error', release, { once: true });

    window.setTimeout(function () {
      seekToFirstFrame();
    }, 160);
    window.setTimeout(release, 2800);

    return true;
  }

  function getReviewMasonryColumnCount() {
    var width = window.innerWidth || document.documentElement.clientWidth || 1020;
    if (width <= 349) return 1;
    if (width <= 509) return 2;
    if (width <= 1019) return 3;
    return 4;
  }

  function getReviewMasonryCards(grid) {
    var cards = [];
    if (!grid) return cards;

    Array.prototype.forEach.call(grid.children, function (child) {
      if (!child || !child.classList) return;

      if (child.classList.contains('mgr-card')) {
        cards.push(child);
        return;
      }

      if (child.classList.contains('mgr-masonry-column')) {
        Array.prototype.forEach.call(child.children, function (card) {
          if (card && card.classList && card.classList.contains('mgr-card')) {
            cards.push(card);
          }
        });
      }
    });

    return stabilizeReviewMasonryCards(grid, cards);
  }

  function stabilizeReviewMasonryCards(grid, cards) {
    if (!grid || !cards || !cards.length) return cards || [];

    var state = reviewMasonryGrids.get(grid) || {};
    var maxOrder = typeof state.nextOrder === 'number' ? state.nextOrder : 0;

    cards.forEach(function (card) {
      var existingOrder = parseInt(card.getAttribute('data-mgr-review-order') || '', 10);
      if (!isNaN(existingOrder)) {
        maxOrder = Math.max(maxOrder, existingOrder + 1);
      }
    });

    cards.forEach(function (card) {
      var existingOrder = parseInt(card.getAttribute('data-mgr-review-order') || '', 10);
      if (isNaN(existingOrder)) {
        card.setAttribute('data-mgr-review-order', String(maxOrder));
        maxOrder += 1;
      }
    });

    state.nextOrder = maxOrder;
    reviewMasonryGrids.set(grid, state);

    cards.sort(function (a, b) {
      var orderA = parseInt(a.getAttribute('data-mgr-review-order') || '0', 10);
      var orderB = parseInt(b.getAttribute('data-mgr-review-order') || '0', 10);
      return orderA - orderB;
    });

    return cards;
  }

  function getReviewMasonryColumns(grid) {
    var columns = [];
    if (!grid) return columns;

    Array.prototype.forEach.call(grid.children, function (child) {
      if (child && child.classList && child.classList.contains('mgr-masonry-column')) {
        columns.push(child);
      }
    });

    return columns;
  }

  function getDirectReviewMasonryCards(grid) {
    var cards = [];
    if (!grid) return cards;

    Array.prototype.forEach.call(grid.children, function (child) {
      if (child && child.classList && child.classList.contains('mgr-card')) {
        cards.push(child);
      }
    });

    cards.sort(function (a, b) {
      var orderA = parseInt(a.getAttribute('data-mgr-review-order') || '0', 10);
      var orderB = parseInt(b.getAttribute('data-mgr-review-order') || '0', 10);
      return orderA - orderB;
    });

    return cards;
  }

  function getReviewMasonryColumnHeight(column) {
    if (!column) return 0;

    // Measure the actual visual bottom of the last card, not the flex column's
    // reported height. Some browsers can report flex column geometry in a way
    // that looks balanced numerically while the visible lane is clearly shorter.
    // Using the last card's bottom makes load-more placement follow what the
    // shopper can actually see on screen.
    var children = column.children ? Array.prototype.slice.call(column.children) : [];
    var lastCard = null;

    for (var i = children.length - 1; i >= 0; i -= 1) {
      if (children[i] && children[i].classList && children[i].classList.contains('mgr-card')) {
        lastCard = children[i];
        break;
      }
    }

    if (lastCard && typeof lastCard.getBoundingClientRect === 'function' && typeof column.getBoundingClientRect === 'function') {
      var columnRect = column.getBoundingClientRect();
      var cardRect = lastCard.getBoundingClientRect();
      var visualHeight = Math.ceil(cardRect.bottom - columnRect.top);
      if (visualHeight > 0) return visualHeight;
    }

    var rect = typeof column.getBoundingClientRect === 'function' ? column.getBoundingClientRect() : null;
    return Math.ceil((rect && rect.height) || column.scrollHeight || column.offsetHeight || 0);
  }

  function getShortestReviewMasonryColumnIndex(columnHeights) {
    var shortestIndex = 0;
    var shortestHeight = columnHeights[0] || 0;

    for (var i = 1; i < columnHeights.length; i += 1) {
      var height = columnHeights[i] || 0;
      if (height < shortestHeight) {
        shortestHeight = height;
        shortestIndex = i;
      }
    }

    return shortestIndex;
  }

  function getReviewMasonryColumnGap(column) {
    if (!column || !window.getComputedStyle) return 14;

    var styles = window.getComputedStyle(column);
    var parsedGap = parseFloat(styles && (styles.rowGap || styles.gap));
    if (!isNaN(parsedGap)) return parsedGap;

    return 14;
  }

  function getMeasuredReviewCardHeight(card) {
    if (!card) return 0;

    var storedHeight = parseFloat(card.getAttribute('data-mgr-measured-height') || '');
    if (!isNaN(storedHeight) && storedHeight > 0) return storedHeight;

    var rect = typeof card.getBoundingClientRect === 'function' ? card.getBoundingClientRect() : null;
    return Math.ceil((rect && rect.height) || card.scrollHeight || card.offsetHeight || 0);
  }

  function appendMeasuredReviewCardToColumn(column, card, columnHeights, columnIndex, gap) {
    if (!column || !card) return;

    // Append first, then re-read the actual visual bottom of that column.
    // This is a little more work than adding a cached height number, but only
    // runs for the 8 load-more cards and prevents the placement error where a
    // visibly shorter column is skipped.
    column.appendChild(card);
    columnHeights[columnIndex] = getReviewMasonryColumnHeight(column);
  }

  function appendReviewCardsToShortestColumns(columns, cards, options) {
    if (!columns || !columns.length || !cards || !cards.length) return;

    options = options || {};

    var gap = getReviewMasonryColumnGap(columns[0]);
    var columnHeights = columns.map(function (column) {
      return getReviewMasonryColumnHeight(column);
    });

    var remainingCards = cards.slice();

    // Important: do not round-robin and do not sort this batch by height. Both
    // approaches can make the wall look wrong after several clicks because they
    // feed a card to a taller lane while a visibly shorter lane is still open.
    // Keep the review order, but before each append choose the column whose
    // actual last-card bottom is currently highest up the page.

    remainingCards.forEach(function (card) {
      var columnIndex = getShortestReviewMasonryColumnIndex(columnHeights);
      appendMeasuredReviewCardToColumn(columns[columnIndex], card, columnHeights, columnIndex, gap);
    });
  }

  function getReviewMasonryColumnWidth(grid, columns, columnCount) {
    var column = columns && columns.length ? columns[0] : null;
    var columnRect = column && typeof column.getBoundingClientRect === 'function' ? column.getBoundingClientRect() : null;
    if (columnRect && columnRect.width) return columnRect.width;

    var gridRect = grid && typeof grid.getBoundingClientRect === 'function' ? grid.getBoundingClientRect() : null;
    var gridWidth = gridRect && gridRect.width ? gridRect.width : 0;
    if (!gridWidth) return 0;

    var gap = 14;
    if (window.getComputedStyle) {
      var styles = window.getComputedStyle(grid);
      var parsedGap = parseFloat(styles && (styles.columnGap || styles.gap));
      if (!isNaN(parsedGap)) gap = parsedGap;
    }

    return Math.max(0, (gridWidth - (gap * Math.max(0, columnCount - 1))) / Math.max(1, columnCount));
  }

  function setReviewCardMediaEager(card) {
    if (!card || !card.querySelectorAll) return;

    Array.prototype.forEach.call(card.querySelectorAll('img'), function (image) {
      try { image.loading = 'eager'; } catch (error) {}
      try { image.decoding = 'async'; } catch (error) {}
    });

    Array.prototype.forEach.call(card.querySelectorAll('video'), function (video) {
      try { video.preload = 'metadata'; } catch (error) {}
      if (typeof video.load === 'function') {
        try { video.load(); } catch (error) {}
      }
    });
  }

  function waitForReviewMediaElement(element) {
    if (!element) return Promise.resolve();

    if (element.tagName === 'IMG') {
      if (element.complete && element.naturalWidth) return Promise.resolve();

      return new Promise(function (resolve) {
        var done = false;
        var finish = function () {
          if (done) return;
          done = true;
          element.removeEventListener('load', finish);
          element.removeEventListener('error', finish);
          resolve();
        };

        element.addEventListener('load', finish, { once: true });
        element.addEventListener('error', finish, { once: true });
        window.setTimeout(finish, 850);
      });
    }

    if (element.tagName === 'VIDEO') {
      if (element.readyState >= 1 || element.videoWidth) return Promise.resolve();

      return new Promise(function (resolve) {
        var done = false;
        var finish = function () {
          if (done) return;
          done = true;
          element.removeEventListener('loadedmetadata', finish);
          element.removeEventListener('loadeddata', finish);
          element.removeEventListener('error', finish);
          resolve();
        };

        element.addEventListener('loadedmetadata', finish, { once: true });
        element.addEventListener('loadeddata', finish, { once: true });
        element.addEventListener('error', finish, { once: true });
        window.setTimeout(finish, 850);
      });
    }

    return Promise.resolve();
  }

  function waitForReviewCardMedia(cards) {
    if (!cards || !cards.length) return Promise.resolve();

    var mediaElements = [];
    cards.forEach(function (card) {
      if (!card || !card.querySelectorAll) return;
      setReviewCardMediaEager(card);
      Array.prototype.forEach.call(card.querySelectorAll('img, video'), function (element) {
        mediaElements.push(element);
      });
    });

    if (!mediaElements.length) return Promise.resolve();

    return Promise.all(mediaElements.map(waitForReviewMediaElement)).then(function () {});
  }

  function measureReviewCardsBeforeMasonryAppend(grid, cards) {
    if (!grid || !cards || !cards.length || !document.body) return Promise.resolve();

    var columnCount = getReviewMasonryColumnCount();
    var columns = getReviewMasonryColumns(grid);
    var columnWidth = getReviewMasonryColumnWidth(grid, columns, columnCount);
    if (!columnWidth) return Promise.resolve();

    var measurer = document.createElement('div');
    measurer.className = 'mgr-masonry-column mgr-load-more-measurer';
    measurer.setAttribute('aria-hidden', 'true');
    measurer.style.position = 'absolute';
    measurer.style.left = '-99999px';
    measurer.style.top = '0';
    measurer.style.width = columnWidth + 'px';
    measurer.style.visibility = 'hidden';
    measurer.style.pointerEvents = 'none';
    measurer.style.zIndex = '-1';

    cards.forEach(function (card) {
      setReviewCardMediaEager(card);
      measurer.appendChild(card);
    });

    document.body.appendChild(measurer);

    return new Promise(function (resolve) {
      window.requestAnimationFrame(function () {
        waitForReviewCardMedia(cards).then(function () {
          window.requestAnimationFrame(resolve);
        });
      });
    }).then(function () {
      cards.forEach(function (card) {
        if (!card) return;
        var rect = typeof card.getBoundingClientRect === 'function' ? card.getBoundingClientRect() : null;
        var height = Math.ceil((rect && rect.height) || card.scrollHeight || card.offsetHeight || 0);
        if (height > 0) card.setAttribute('data-mgr-measured-height', String(height));
      });
    }).finally(function () {
      if (measurer && measurer.parentNode) {
        measurer.parentNode.removeChild(measurer);
      }
    });
  }

  function getReviewMasonryGridGap(grid) {
    if (!grid || !window.getComputedStyle) return 14;

    var styles = window.getComputedStyle(grid);

    // This is the desired visible space between masonry cards. It is kept as a
    // CSS variable instead of using real CSS row-gap because CSS-grid row-span
    // masonry multiplies row-gap inside every spanned item. That multiplication
    // was creating the oversized blank space under short text-only reviews.
    var customGap = styles && styles.getPropertyValue && parseFloat(styles.getPropertyValue('--mgr-masonry-row-gap'));
    if (!isNaN(customGap)) return customGap;

    var parsedGap = parseFloat(styles && (styles.rowGap || styles.gap));
    if (!isNaN(parsedGap)) return parsedGap;

    return 14;
  }

  function getReviewMasonryGridRowHeight(grid) {
    if (!grid || !window.getComputedStyle) return 4;

    var styles = window.getComputedStyle(grid);
    var parsedRow = parseFloat(styles && styles.gridAutoRows);
    if (!isNaN(parsedRow) && parsedRow > 0) return parsedRow;

    return 4;
  }

  function unwrapReviewMasonryColumns(grid, cards) {
    if (!grid || !cards || !cards.length) return;

    var hasColumns = getReviewMasonryColumns(grid).length > 0;
    if (!hasColumns) return;

    while (grid.firstChild) {
      grid.removeChild(grid.firstChild);
    }

    cards.forEach(function (card) {
      grid.appendChild(card);
    });
  }

  function markReviewMasonryMediaForSpanRefresh(grid, card) {
    if (!grid || !card || !card.querySelectorAll || card.getAttribute('data-mgr-span-media-bound') === 'true') return;

    card.setAttribute('data-mgr-span-media-bound', 'true');

    Array.prototype.forEach.call(card.querySelectorAll('img, video'), function (media) {
      var refresh = function () {
        scheduleReviewMasonrySpanRefresh(grid, card);
      };

      if (media.tagName === 'IMG') {
        if (!(media.complete && media.naturalWidth)) {
          media.addEventListener('load', refresh, { once: true });
          media.addEventListener('error', refresh, { once: true });
        }
        return;
      }

      if (media.tagName === 'VIDEO') {
        if (!(media.readyState >= 1 || media.videoWidth)) {
          media.addEventListener('loadedmetadata', refresh, { once: true });
          media.addEventListener('loadeddata', refresh, { once: true });
          media.addEventListener('error', refresh, { once: true });
        }
      }
    });
  }

  function updateReviewMasonryCardSpan(grid, card) {
    if (!grid || !card || !card.style) return;

    var rowHeight = getReviewMasonryGridRowHeight(grid);
    var gap = getReviewMasonryGridGap(grid);

    // Let the card keep its natural height, then translate that height into
    // CSS-grid rows. This removes the fragile flex-column bookkeeping entirely:
    // the browser places each card into the next available masonry slot, while
    // existing cards keep their DOM order and do not need to be manually moved.
    var rect = typeof card.getBoundingClientRect === 'function' ? card.getBoundingClientRect() : null;
    var height = Math.ceil((rect && rect.height) || card.scrollHeight || card.offsetHeight || 0);
    if (!height) return;

    // The grid uses row-gap: 0 and reserves the desired card-to-card spacing
    // inside each item's row span. This keeps the visual vertical gap precise
    // instead of snapping short text-only reviews to big row-gap increments.
    var span = Math.max(1, Math.ceil((height + gap) / rowHeight));
    card.style.gridRowEnd = 'span ' + span;
    card.setAttribute('data-mgr-masonry-placed', 'true');
  }

  function updateReviewMasonrySpans(grid, cards) {
    if (!grid) return;

    cards = cards && cards.length ? cards : getReviewMasonryCards(grid);
    if (!cards.length) return;

    var rowHeight = getReviewMasonryGridRowHeight(grid);
    var gap = getReviewMasonryGridGap(grid);

    // PASS 1 — reads only.
    // Bind media listeners and read every card's rendered height up front.
    // The old code read getBoundingClientRect() and then wrote style.gridRowEnd
    // for the same card inside one loop. The write dirties layout, so the next
    // card's read forced the browser to recompute layout synchronously — one
    // forced reflow PER card. A 20-card batch meant 20 reflows on a single
    // frame (and the "remeasure all" paths meant hundreds), which is exactly
    // the dropped-frame lag on load-more. A card's own rendered height does not
    // depend on any other card's row span, so reading all heights first is
    // functionally identical and lets us avoid the interleaved reflows.
    var measurements = [];
    cards.forEach(function (card) {
      if (!card || !card.style) return;
      markReviewMasonryMediaForSpanRefresh(grid, card);
      var rect = typeof card.getBoundingClientRect === 'function' ? card.getBoundingClientRect() : null;
      var height = Math.ceil((rect && rect.height) || card.scrollHeight || card.offsetHeight || 0);
      if (!height) return;
      measurements.push({ card: card, height: height });
    });

    // PASS 2 — writes only.
    // With all reads complete, applying spans can no longer trigger a reflow
    // between measurements: the whole batch settles in a single layout pass.
    measurements.forEach(function (entry) {
      var span = Math.max(1, Math.ceil((entry.height + gap) / rowHeight));
      entry.card.style.gridRowEnd = 'span ' + span;
      entry.card.setAttribute('data-mgr-masonry-placed', 'true');
    });
  }

  function scheduleReviewMasonrySpanRefresh(grid, card) {
    if (!grid || !window.requestAnimationFrame) {
      if (card) {
        updateReviewMasonrySpans(grid, [card]);
      } else {
        updateReviewMasonrySpans(grid);
      }
      return;
    }

    // Media load events fire at staggered times as each photo/video finishes
    // downloading. The old code scheduled a separate rAF per card, so several
    // images completing in the same frame still produced an interleaved
    // read/write reflow chain across those callbacks. Collect every card that
    // changed into one grid-level set and remeasure them together in a single
    // batched (reads-then-writes) pass.
    if (!grid.__mgrSpanRefreshCards) grid.__mgrSpanRefreshCards = [];

    if (card) {
      if (grid.__mgrSpanRefreshCards.indexOf(card) === -1) {
        grid.__mgrSpanRefreshCards.push(card);
      }
    } else {
      grid.__mgrSpanRefreshAll = true;
    }

    if (grid.__mgrSpanRefreshRaf) return;

    grid.__mgrSpanRefreshRaf = window.requestAnimationFrame(function () {
      grid.__mgrSpanRefreshRaf = null;
      var refreshAll = grid.__mgrSpanRefreshAll;
      var pending = grid.__mgrSpanRefreshCards || [];
      grid.__mgrSpanRefreshAll = false;
      grid.__mgrSpanRefreshCards = [];

      if (refreshAll) {
        updateReviewMasonrySpans(grid);
      } else if (pending.length) {
        updateReviewMasonrySpans(grid, pending);
      }
    });
  }

  function arrangeReviewMasonryGrid(grid, changedCards) {
    if (!grid) return;

    var cards = getReviewMasonryCards(grid);
    if (!cards.length) return;

    var columnCount = getReviewMasonryColumnCount();
    var state = reviewMasonryGrids.get(grid) || {};
    var hadColumns = getReviewMasonryColumns(grid).length > 0;
    var columnCountChanged = state.columnCount !== columnCount;

    grid.classList.add('mgr-masonry-grid');
    grid.classList.add('mgr-css-grid-masonry');
    grid.setAttribute('data-mgr-masonry-columns', String(columnCount));

    // CSS Grid does the masonry placement. The expensive part is measuring card
    // heights, so on load-more we only measure the new cards. Existing cards keep
    // their stored spans unless the column count changed.
    unwrapReviewMasonryColumns(grid, cards);

    var targetCards = [];
    if (columnCountChanged || hadColumns) {
      targetCards = cards;
    } else if (changedCards && changedCards.length) {
      targetCards = Array.prototype.slice.call(changedCards);
    } else {
      targetCards = cards.filter(function (card) {
        return !card.getAttribute('data-mgr-masonry-placed');
      });
    }

    if (!targetCards.length) targetCards = cards;

    updateReviewMasonrySpans(grid, targetCards);

    // A second full pass used to run here on every click. That was visible as a
    // delay/frame drop once the grid had hundreds of reviews. Only repeat the
    // tiny changed set so media dimensions can settle without remeasuring the
    // whole wall.
    if (window.requestAnimationFrame && targetCards.length <= 24) {
      window.requestAnimationFrame(function () {
        updateReviewMasonrySpans(grid, targetCards);
      });
    }

    state.columnCount = columnCount;
    reviewMasonryGrids.set(grid, state);
  }

  function arrangeAllReviewMasonryGrids() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-mgr-grid], [data-mgr-modal-grid]'), function (grid) {
      arrangeReviewMasonryGrid(grid);
    });
  }

  function scheduleReviewMasonryLayout() {
    if (reviewMasonryResizeTimer) {
      window.clearTimeout(reviewMasonryResizeTimer);
    }

    reviewMasonryResizeTimer = window.setTimeout(function () {
      reviewMasonryResizeTimer = null;
      arrangeAllReviewMasonryGrids();
    }, 120);
  }

  function runWithInstantReviewScroll(callback) {
    var doc = document.documentElement;
    var body = document.body;
    var previousDocScrollBehavior = doc && doc.style ? doc.style.scrollBehavior : '';
    var previousBodyScrollBehavior = body && body.style ? body.style.scrollBehavior : '';

    if (doc && doc.style) doc.style.scrollBehavior = 'auto';
    if (body && body.style) body.style.scrollBehavior = 'auto';

    try {
      callback();
    } finally {
      window.setTimeout(function () {
        if (doc && doc.style) doc.style.scrollBehavior = previousDocScrollBehavior;
        if (body && body.style) body.style.scrollBehavior = previousBodyScrollBehavior;
      }, 0);
    }
  }

  function scrollReviewWindowBy(deltaX, deltaY) {
    if (typeof window.scrollBy !== 'function') return;
    runWithInstantReviewScroll(function () {
      try {
        window.scrollBy({ left: deltaX || 0, top: deltaY || 0, behavior: 'auto' });
      } catch (error) {
        window.scrollBy(deltaX || 0, deltaY || 0);
      }
    });
  }

  function scrollReviewWindowTo(x, y) {
    if (typeof window.scrollTo !== 'function') return;
    runWithInstantReviewScroll(function () {
      try {
        window.scrollTo({ left: x || 0, top: y || 0, behavior: 'auto' });
      } catch (error) {
        window.scrollTo(x || 0, y || 0);
      }
    });
  }

  function createReviewScrollAnchor(anchorElement) {
    if (!anchorElement || !anchorElement.parentNode) return null;

    var marker = document.createElement('span');
    marker.setAttribute('data-mgr-scroll-anchor', 'true');
    marker.setAttribute('aria-hidden', 'true');
    marker.style.display = 'block';
    marker.style.height = '0';
    marker.style.overflow = 'hidden';
    marker.style.pointerEvents = 'none';
    marker.style.visibility = 'hidden';

    anchorElement.parentNode.insertBefore(marker, anchorElement);

    var rect = marker.getBoundingClientRect();
    return {
      marker: marker,
      top: rect.top,
      left: rect.left,
      x: window.pageXOffset || document.documentElement.scrollLeft || 0,
      y: window.pageYOffset || document.documentElement.scrollTop || 0
    };
  }

  function restoreReviewScrollAnchor(anchor) {
    if (!anchor) return;

    if (anchor.marker && anchor.marker.parentNode && typeof anchor.marker.getBoundingClientRect === 'function') {
      var rect = anchor.marker.getBoundingClientRect();
      var deltaX = rect.left - anchor.left;
      var deltaY = rect.top - anchor.top;

      if (Math.abs(deltaX) > 0.5 || Math.abs(deltaY) > 0.5) {
        scrollReviewWindowBy(deltaX, deltaY);
      }

      return;
    }

    scrollReviewWindowTo(anchor.x, anchor.y);
  }

  function settleReviewScrollAnchor(anchor) {
    if (!anchor) return;

    restoreReviewScrollAnchor(anchor);

    window.requestAnimationFrame(function () {
      restoreReviewScrollAnchor(anchor);
      window.requestAnimationFrame(function () {
        restoreReviewScrollAnchor(anchor);
      });
    });

    [40, 140, 320, 700, 1200, 2200, 3000].forEach(function (delay) {
      window.setTimeout(function () {
        restoreReviewScrollAnchor(anchor);
      }, delay);
    });

    window.setTimeout(function () {
      if (anchor.marker && anchor.marker.parentNode) {
        anchor.marker.parentNode.removeChild(anchor.marker);
      }
    }, 3400);
  }


  function getReviewWindowScrollPosition() {
    var doc = document.documentElement || {};
    var body = document.body || {};

    return {
      x: window.pageXOffset || doc.scrollLeft || body.scrollLeft || 0,
      y: window.pageYOffset || doc.scrollTop || body.scrollTop || 0
    };
  }

  function restoreReviewWindowScrollPosition(position) {
    if (!position || typeof window.scrollTo !== 'function') return;
    scrollReviewWindowTo(position.x || 0, position.y || 0);
  }

  function settleReviewWindowScrollPosition(position) {
    if (!position) return;

    restoreReviewWindowScrollPosition(position);

    window.requestAnimationFrame(function () {
      restoreReviewWindowScrollPosition(position);
      window.requestAnimationFrame(function () {
        restoreReviewWindowScrollPosition(position);
      });
    });

    window.setTimeout(function () {
      restoreReviewWindowScrollPosition(position);
    }, 40);

    window.setTimeout(function () {
      restoreReviewWindowScrollPosition(position);
    }, 140);

    window.setTimeout(function () {
      restoreReviewWindowScrollPosition(position);
    }, 320);
  }

  function getReviewElementScrollPosition(element) {
    if (!element) return null;

    return {
      x: element.scrollLeft || 0,
      y: element.scrollTop || 0
    };
  }

  function restoreReviewElementScrollPosition(element, position) {
    if (!element || !position) return;
    element.scrollLeft = position.x || 0;
    element.scrollTop = position.y || 0;
  }

  function settleReviewElementScrollPosition(element, position) {
    if (!element || !position) return;

    restoreReviewElementScrollPosition(element, position);

    window.requestAnimationFrame(function () {
      restoreReviewElementScrollPosition(element, position);
      window.requestAnimationFrame(function () {
        restoreReviewElementScrollPosition(element, position);
      });
    });

    [40, 140, 320].forEach(function (delay) {
      window.setTimeout(function () {
        restoreReviewElementScrollPosition(element, position);
      }, delay);
    });
  }

  function getReviewScrollPosition(scrollContainer) {
    return scrollContainer ? getReviewElementScrollPosition(scrollContainer) : getReviewWindowScrollPosition();
  }

  function settleReviewScrollPosition(scrollContainer, position) {
    if (scrollContainer) {
      settleReviewElementScrollPosition(scrollContainer, position);
      return;
    }

    settleReviewWindowScrollPosition(position);
  }

  function revealLoadedReviewCards(cards) {
    if (!cards || !cards.length) return;

    var pendingCards = Array.prototype.slice.call(cards).filter(function (card) {
      return !!(card && card.classList && card.classList.contains('is-mgr-loadmore-fade-pending'));
    });

    if (!pendingCards.length) return;

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        pendingCards.forEach(function (card) {
          if (card && card.classList) card.classList.add('is-mgr-loadmore-fade-visible');
        });
      });
    });

    window.setTimeout(function () {
      pendingCards.forEach(function (card) {
        if (!card || !card.classList) return;
        card.classList.remove('is-mgr-loadmore-fade-pending');
        card.classList.remove('is-mgr-loadmore-fade-visible');
      });
    }, 420);
  }

  if (window.addEventListener) {
    window.addEventListener('resize', scheduleReviewMasonryLayout);
    window.addEventListener('orientationchange', scheduleReviewMasonryLayout);
  }

  var trustBannerListenersBound = false;
  var SCRIPT_SRC = document.currentScript && document.currentScript.src ? document.currentScript.src : '';
  var detailScrollY = 0;
  var detailScrollLocked = false;
  var detailAnimationFrame = null;
  var detailCloseTimer = null;
  var modalAnimationFrame = null;
  var modalCloseTimer = null;
  var productImageCache = {};

  var verifyPopoverCloseTimer = null;
  var verifySheetCloseTimer = null;
  var MGR_LANG = getCurrentLanguage();
  var MGR_I18N = {
    en: {
      verifiedCustomer: 'Verified Customer',
      verifiedPurchase: 'Verified purchase',
      openReviewFrom: 'Open review from {name}',
      customerReviewPhoto: 'Customer review photo',
      reviewedProduct: 'Reviewed product',
      outOfFiveStars: '{rating} out of 5 stars',
      verifiedLabel: 'Verified',
      moreVerifiedInfo: 'More information about verified reviews',
      verifiedInfo: 'This review was collected from a verified customer who purchased this item.',
      learnMore: 'Learn more',
      howWeVerifyTitle: 'How we verify and process reviews',
      closeVerificationInfo: 'Close review verification information',
      closeReview: 'Close review',
      viewProduct: 'View product',
      headerTitle: 'La Familia Mexicada',
      headerSubtitle: 'From our gente, across the collection',
      headerCount: '14,764 Reviews',
      ratingSummaryAria: 'Average rating 5.0 out of 5',
      sheetParagraph1: 'We collect customer reviews from people who share feedback after ordering. When a review is marked verified, it means we matched that feedback to an order or purchase record before showing the verified label.',
      sheetParagraph2: 'Verified reviews help shoppers see feedback from real customers who received an item from our collection. When available, we may include customer-submitted photos, product names, and helpful context so the review is easier to understand.',
      sheetParagraph3: 'We may verify reviews, both those posted directly on our site and those imported from other sources, using fair, proportionate methods, such as asking for valid proof that the customer actually purchased or used the product. When a review passes this check, it is marked "Verified purchase."',
      sheetParagraph4: 'Customers rate products on a scale from 1 to 5. We calculate the average score as a straight mathematical average, then round it to the nearest half or full star using standard rounding. This average includes reviews from customers who received a discount on a future purchase for adding a photo or video to their review.',
      sheetParagraph5: 'Some reviews come from customers reviewing multiple products across our collection. We show these as storewide customer feedback so shoppers can see more real experiences with Mexicada supplied products.',
      speedLabel: 'Speed:',
      qualityLabel: 'Quality:'
    },
    es: {
      verifiedCustomer: 'Cliente verificado',
      verifiedPurchase: 'Compra verificada',
      openReviewFrom: 'Abrir reseña de {name}',
      customerReviewPhoto: 'Foto de reseña de cliente',
      reviewedProduct: 'Producto reseñado',
      outOfFiveStars: '{rating} de 5 estrellas',
      verifiedLabel: 'Verificado',
      moreVerifiedInfo: 'Más información sobre reseñas verificadas',
      verifiedInfo: 'Esta reseña fue recopilada de un cliente verificado que compró este artículo.',
      learnMore: 'Más información',
      howWeVerifyTitle: 'Cómo verificamos y procesamos las reseñas',
      closeVerificationInfo: 'Cerrar información sobre verificación de reseñas',
      closeReview: 'Cerrar reseña',
      viewProduct: 'Ver producto',
      headerTitle: 'La familia Mexicada',
      headerSubtitle: 'De nuestra gente, a través de la colección',
      headerCount: '14,764 reseñas',
      ratingSummaryAria: 'Calificación promedio 5.0 de 5',
sheetParagraph1: 'Recopilamos reseñas de clientes que comparten sus opiniones después de realizar un pedido. Cuando una reseña se marca como verificada, significa que vinculamos esos comentarios con un registro de pedido o compra antes de mostrar la etiqueta de verificación.',
      sheetParagraph2: 'Las reseñas verificadas ayudan a los compradores a ver comentarios de clientes reales que recibieron un artículo de nuestra colección. Cuando están disponibles, podemos incluir fotos enviadas por los clientes, nombres de los productos y contexto útil para que la reseña sea más fácil de entender.',
      sheetParagraph3: 'Podemos verificar las reseñas, tanto las publicadas directamente en nuestro sitio como las importadas de otras fuentes, utilizando métodos justos y proporcionales, como solicitar pruebas válidas de que el cliente realmente compró o usó el producto. Cuando una reseña pasa esta comprobación, se marca como "Compra verificada".',
      sheetParagraph4: 'Los clientes califican los productos en una escala del 1 al 5. Calculamos la puntuación promedio como un promedio matemático simple y luego lo redondeamos a la mitad o a la estrella completa más cercana utilizando el redondeo estándar. Este promedio incluye reseñas de clientes que recibieron un descuento en una compra futura por agregar una foto o un video a su reseña.',
      sheetParagraph5: 'Algunas reseñas provienen de clientes que evalúan múltiples productos de nuestra colección. Las mostramos como opiniones de clientes de toda la tienda para que los compradores puedan ver más experiencias reales con los productos provistos por Mexicada.',
            speedLabel: 'Velocidad:',
      qualityLabel: 'Calidad:'
    },
    fr: {
      verifiedCustomer: 'Client vérifié',
      verifiedPurchase: 'Achat vérifié',
      openReviewFrom: 'Ouvrir l’avis de {name}',
      customerReviewPhoto: 'Photo d’avis client',
      reviewedProduct: 'Produit évalué',
      outOfFiveStars: '{rating} sur 5 étoiles',
      verifiedLabel: 'Vérifié',
      moreVerifiedInfo: 'Plus d’informations sur les avis vérifiés',
      verifiedInfo: 'Cet avis a été recueilli auprès d’un client vérifié ayant acheté cet article.',
      learnMore: 'En savoir plus',
      howWeVerifyTitle: 'Comment nous vérifions et traitons les avis',
      closeVerificationInfo: 'Fermer les informations de vérification des avis',
      closeReview: 'Fermer l’avis',
      viewProduct: 'Voir le produit',
      headerTitle: 'La Familia Mexicada',
      headerSubtitle: 'De notre gente, à travers toute la collection',
      headerCount: '14 764 avis',
      ratingSummaryAria: 'Note moyenne 5,0 sur 5',
sheetParagraph1: 'Nous recueillons les avis de clients qui partagent leurs commentaires après avoir passé commande. Lorsqu\'un avis est marqué comme vérifié, cela signifie que nous avons associé ces commentaires à un dossier de commande ou d\'achat avant d\'afficher l\'étiquette vérifiée.',
      sheetParagraph2: 'Les avis vérifiés aident les acheteurs à voir les commentaires de vrais clients qui ont reçu un article de notre collection. Lorsqu\'ils sont disponibles, nous pouvons inclure des photos soumises par les clients, les noms de produits et un contexte utile pour que l\'avis soit plus facile à comprendre.',
      sheetParagraph3: 'Nous pouvons vérifier les avis, qu\'ils soient publiés directement sur notre site ou importés d\'autres sources, en utilisant des méthodes justes et proportionnées, comme demander une preuve valide que le client a réellement acheté ou utilisé le produit. Lorsqu\'un avis passe cette vérification, il est marqué "Achat vérifié".',
      sheetParagraph4: 'Les clients évaluent les produits sur une échelle de 1 à 5. Nous calculons la note moyenne sous forme de moyenne mathématique simple, puis nous l\'arrondissons à la demi-étoile ou à l\'étoile entière la plus proche en utilisant l\'arrondi standard. Cette moyenne inclut les avis des clients qui ont reçu une réduction sur un achat futur pour avoir ajouté une photo ou une vidéo à leur avis.',
      sheetParagraph5: 'Certains avis proviennent de clients évaluant plusieurs produits de notre collection. Nous les affichons sous forme de commentaires clients à l\'échelle de la boutique afin que les acheteurs puissent voir davantage d\'expériences réelles avec les produits fournis par Mexicada.',
            speedLabel: 'Vitesse:',
      qualityLabel: 'Qualité:'
    },
    de: {
      verifiedCustomer: 'Verifizierter Kunde',
      verifiedPurchase: 'Verifizierter Kauf',
      openReviewFrom: 'Bewertung von {name} öffnen',
      customerReviewPhoto: 'Foto aus einer Kundenbewertung',
      reviewedProduct: 'Bewertetes Produkt',
      outOfFiveStars: '{rating} von 5 Sternen',
      verifiedLabel: 'Verifiziert',
      moreVerifiedInfo: 'Mehr Informationen zu verifizierten Bewertungen',
      verifiedInfo: 'Diese Bewertung wurde von einem verifizierten Kunden gesammelt, der diesen Artikel gekauft hat.',
      learnMore: 'Mehr erfahren',
      howWeVerifyTitle: 'Wie wir Bewertungen prüfen und verarbeiten',
      closeVerificationInfo: 'Informationen zur Bewertungsprüfung schließen',
      closeReview: 'Bewertung schließen',
      viewProduct: 'Produkt ansehen',
      headerTitle: 'Die Familie Mexicada',
      headerSubtitle: 'Von unserer gente, aus der ganzen Kollektion',
      headerCount: '14.764 Bewertungen',
      ratingSummaryAria: 'Durchschnittliche Bewertung 5,0 von 5',
sheetParagraph1: 'Wir sammeln Kundenrezensionen von Personen, die nach der Bestellung Feedback geben. Wenn eine Rezension als verifiziert markiert ist, bedeutet dies, dass wir dieses Feedback mit einem Bestell- oder Kaufbeleg abgeglichen haben, bevor wir das Label verifiziert anzeigen.',
      sheetParagraph2: 'Verifizierte Rezensionen helfen Käufern, Feedback von echten Kunden zu sehen, die einen Artikel aus unserer Kollektion erhalten haben. Sofern verfügbar, fügen wir möglicherweise von Kunden eingereichte Fotos, Produktnamen und hilfreichen Kontext hinzu, damit die Rezension leichter verständlich ist.',
      sheetParagraph3: 'Wir können Rezensionen, sowohl solche, die direkt auf unserer Website veröffentlicht wurden, als auch solche, die aus anderen Quellen importiert wurden, mit fairen, angemessenen Methoden überprüfen, z. B. indem wir einen gültigen Nachweis anfordern, dass der Kunde das Produkt tatsächlich gekauft oder verwendet hat. Wenn eine Rezension diese Prüfung besteht, wird sie als "Verifizierter Kauf" markiert.',
      sheetParagraph4: 'Kunden bewerten Produkte auf einer Skala von 1 bis 5. Wir berechnen die Durchschnittspunktzahl als einfachen mathematischen Durchschnitt und runden sie dann mit Standardrundung auf den nächsten halben oder ganzen Stern. Dieser Durchschnitt umfasst Rezensionen von Kunden, die für das Hinzufügen eines Fotos oder Videos zu ihrer Rezension einen Rabatt auf einen zukünftigen Kauf erhalten haben.',
      sheetParagraph5: 'Einige Rezensionen stammen von Kunden, die mehrere Produkte aus unserer Kollektion bewerten. Wir zeigen diese als shopweites Kundenfeedback an, damit Käufer mehr echte Erfahrungen mit von Mexicada gelieferten Produkten sehen können.',
            speedLabel: 'Tempo:',
      qualityLabel: 'Qualität:'
    },
    it: {
      verifiedCustomer: 'Cliente verificato',
      verifiedPurchase: 'Acquisto verificato',
      openReviewFrom: 'Apri la recensione di {name}',
      customerReviewPhoto: 'Foto della recensione del cliente',
      reviewedProduct: 'Prodotto recensito',
      outOfFiveStars: '{rating} su 5 stelle',
      verifiedLabel: 'Verificato',
      moreVerifiedInfo: 'Maggiori informazioni sulle recensioni verificate',
      verifiedInfo: 'Questa recensione è stata raccolta da un cliente verificato che ha acquistato questo articolo.',
      learnMore: 'Scopri di più',
      howWeVerifyTitle: 'Come verifichiamo e gestiamo le recensioni',
      closeVerificationInfo: 'Chiudi le informazioni sulla verifica delle recensioni',
      closeReview: 'Chiudi recensione',
      viewProduct: 'Vedi prodotto',
      headerTitle: 'La famiglia Mexicada',
      headerSubtitle: 'Dalla nostra gente, in tutta la collezione',
      headerCount: '14.764 recensioni',
      ratingSummaryAria: 'Valutazione media 5,0 su 5',
sheetParagraph1: 'Raccogliamo recensioni dei clienti da persone che condividono feedback dopo aver ordinato. Quando una recensione è contrassegnata come verificata, significa che abbiamo associato quel feedback a un ordine o a una registrazione di acquisto prima di mostrare l\'etichetta di verifica.',
      sheetParagraph2: 'Le recensioni verificate aiutano gli acquirenti a vedere il feedback dei clienti reali che hanno ricevuto un articolo dalla nostra collezione. Quando disponibili, potremmo includere foto inviate dai clienti, nomi dei prodotti e un contesto utile per rendere la recensione più facile da capire.',
      sheetParagraph3: 'Possiamo verificare le recensioni, sia quelle pubblicate direttamente sul nostro sito sia quelle importate da altre fonti, utilizzando metodi equi e proporzionati, come la richiesta di prove valide che il cliente abbia effettivamente acquistato o utilizzato il prodotto. Quando una recensione supera questo controllo, viene contrassegnata come "Acquisto verificato".',
      sheetParagraph4: 'I clienti valutano i prodotti su una scala da 1 a 5. Calcoliamo il punteggio medio come una semplice media matematica, quindi lo arrotondiamo alla mezza stella o alla stella intera più vicina utilizzando l\'arrotondamento standard. Questa media include le recensioni dei clienti che hanno ricevuto uno sconto su un acquisto futuro per aver aggiunto una foto o un video alla loro recensione.',
      sheetParagraph5: 'Alcune recensioni provengono da clienti che valutano più prodotti della nostra collezione. Le mostriamo come feedback dei clienti a livello di negozio in modo che gli acquirenti possano vedere più esperienze reali con i prodotti forniti da Mexicada.',
            speedLabel: 'Velocità:',
      qualityLabel: 'Qualità:'
    }
  };

  function getBuiltinReviewTranslation(review, field, lang) {
    // Legacy demo-review translation fallbacks were intentionally removed.
    // Real translations should come from the review JSON itself.
    return '';
  }


  function getCookieValue(name) {
    var escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var match = document.cookie.match(new RegExp('(?:^|;\s*)' + escapedName + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function normalizeLanguageCode(value) {
    value = String(value || '').toLowerCase().trim();
    if (!value) return '';

    if (value.indexOf('/') !== -1) {
      var parts = value.split('/').filter(Boolean);
      value = parts.length ? parts[parts.length - 1] : '';
    }

    value = value.replace(/^auto$/, '').replace(/^en$/, 'en');
    if (value.indexOf('-') !== -1) value = value.split('-')[0];
    if (value.indexOf('_') !== -1) value = value.split('_')[0];

    return /^(es|fr|de|it|en)$/.test(value) ? value : '';
  }

  function getCurrentLanguage() {
    var pathMatch = window.location.pathname.match(/(?:^|\/)(es|fr|de|it)(?=\/|$)/);
    if (pathMatch) return pathMatch[1];

    var shopifyLocale = normalizeLanguageCode(window.Shopify && window.Shopify.locale);
    if (shopifyLocale && shopifyLocale !== 'en') return shopifyLocale;

    var htmlLang = normalizeLanguageCode(document.documentElement.getAttribute('lang'));
    if (htmlLang && htmlLang !== 'en') return htmlLang;

    var googleTranslateCookie = normalizeLanguageCode(getCookieValue('googtrans'));
    if (googleTranslateCookie && googleTranslateCookie !== 'en') return googleTranslateCookie;

    var possibleStorageKeys = [
      'googtrans',
      'gtranslate_selected_lang',
      'gt_current_lang',
      'glang',
      'selectedLanguage',
      'language'
    ];

    for (var index = 0; index < possibleStorageKeys.length; index += 1) {
      try {
        var stored = normalizeLanguageCode(window.localStorage && window.localStorage.getItem(possibleStorageKeys[index]));
        if (stored && stored !== 'en') return stored;
      } catch (err) {
        // Ignore blocked storage.
      }
    }

    var activeSwitcher = document.querySelector('.switcher .selected, .gt_selected, .gt-current-lang, [data-gt-lang].active, [data-gt-lang].selected');
    var activeSwitcherLang = activeSwitcher ? normalizeLanguageCode(activeSwitcher.getAttribute('data-gt-lang') || activeSwitcher.getAttribute('lang') || activeSwitcher.textContent) : '';
    if (activeSwitcherLang && activeSwitcherLang !== 'en') return activeSwitcherLang;

    return 'en';
  }

  function refreshLanguage() {
    MGR_LANG = getCurrentLanguage();
    return MGR_LANG;
  }

  function t(key) {
    var lang = refreshLanguage();
    var pack = MGR_I18N[lang] || MGR_I18N.en;
    return pack[key] || MGR_I18N.en[key] || key;
  }

  function getVideoUiLabel(key) {
    var section = document.querySelector(SECTION_SELECTOR);
    var attr = key === 'speedLabel' ? 'data-mgr-video-speed-label' : 'data-mgr-video-quality-label';
    var fromSection = section && section.getAttribute(attr);
    return fromSection || t(key);
  }

  function isTranslatedLocale() {
    return refreshLanguage() !== 'en';
  }

  function translatedClass(baseClass) {
    return baseClass + (isTranslatedLocale() ? ' notranslate gtranslate-no-translate gt-skip' : '');
  }

  function translatedAttr() {
    return isTranslatedLocale() ? ' translate="no"' : '';
  }

  function markNoTranslate(element) {
    if (!element || !isTranslatedLocale()) return;
    element.classList.add('notranslate');
    element.classList.add('gtranslate-no-translate');
    element.classList.add('gt-skip');
    element.setAttribute('translate', 'no');
  }

  function getReviewTranslations(review) {
    if (!review) return null;
    var lang = refreshLanguage();
    var translations = review.translations || review.i18n || {};
    return translations[lang] || translations[lang.toLowerCase()] || translations[lang.toUpperCase()] || null;
  }

  function hasReviewTranslation(review, field) {
    var lang = refreshLanguage();
    var translations = getReviewTranslations(review);
    return !!(lang !== 'en' && (
      (translations && translations[field]) ||
      (review && review[field + '_' + lang]) ||
      (review && review[lang + '_' + field]) ||
      getBuiltinReviewTranslation(review, field, lang)
    ));
  }

  function getReviewField(review, field, fallback) {
    var lang = refreshLanguage();
    var translations = getReviewTranslations(review);
    if (translations && translations[field]) return translations[field];
    if (review && review[field + '_' + lang]) return review[field + '_' + lang];
    if (review && review[lang + '_' + field]) return review[lang + '_' + field];

    var builtinTranslation = getBuiltinReviewTranslation(review, field, lang);
    if (builtinTranslation) return builtinTranslation;

    if (review && review[field]) return review[field];
    return fallback || '';
  }

  function setLocalizedText(element, text, isTranslated) {
    if (!element) return;
    element.textContent = text || '';
    if (isTranslated) markNoTranslate(element);
  }

  function removeNoTranslate(element) {
    if (!element) return;
    element.classList.remove('notranslate');
    element.classList.remove('gtranslate-no-translate');
    element.classList.remove('gt-skip');
    element.removeAttribute('translate');
  }

  function setStaticTranslatedText(element, text) {
    if (!element) return;
    element.textContent = text || '';
    if (isTranslatedLocale()) {
      markNoTranslate(element);
    } else {
      removeNoTranslate(element);
    }
  }

  function updateStaticReviewCopy(root) {
    refreshLanguage();
    root = root || document;

    var titleSelectors = [
      '.mexicada-global-reviews__title',
      '.mgr-modal__title'
    ];
    var subtitleSelectors = [
      '.mexicada-global-reviews__subtitle',
      '.mgr-modal__subtitle'
    ];
    var countSelectors = [
      '.mexicada-global-reviews__count'
    ];
    var summarySelectors = [
      '.mexicada-global-reviews__summary',
      '.mgr-modal__summary'
    ];

    titleSelectors.forEach(function (selector) {
      root.querySelectorAll(selector).forEach(function (element) {
        setStaticTranslatedText(element, t('headerTitle'));
      });
    });

    subtitleSelectors.forEach(function (selector) {
      root.querySelectorAll(selector).forEach(function (element) {
        setStaticTranslatedText(element, t('headerSubtitle'));
      });
    });

    countSelectors.forEach(function (selector) {
      root.querySelectorAll(selector).forEach(function (element) {
        // Keep product-page and modal counts synced to the same daily count.
        // Do not let the modal fall back to a stale hardcoded review count.
        applyDynamicReviewCount(element);
      });
    });

    summarySelectors.forEach(function (selector) {
      root.querySelectorAll(selector).forEach(function (element) {
        element.setAttribute('aria-label', t('ratingSummaryAria'));
      });
    });
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function lockDetailPageScroll() {
    if (detailScrollLocked) return;

    var doc = document.documentElement;
    var body = document.body;
    detailScrollY = window.pageYOffset || doc.scrollTop || (body && body.scrollTop) || 0;

    doc.classList.add('mgr-detail-modal-open');
    if (body) body.classList.add('mgr-detail-modal-open');

    detailScrollLocked = true;

    // Do not use body { position: fixed } here. On some Shopify themes and
    // mobile browsers it visually jumps the storefront to the top when the
    // modal opens. Overflow locking preserves the current scroll position.
    restoreDetailScrollPosition();
  }

  function restoreDetailScrollPosition() {
    var y = detailScrollY || 0;
    if (typeof window.scrollTo !== 'function') return;

    window.scrollTo(0, y);
    window.requestAnimationFrame(function () {
      window.scrollTo(0, y);
      window.requestAnimationFrame(function () {
        window.scrollTo(0, y);
      });
    });
  }

  function unlockDetailPageScroll() {
    if (!detailScrollLocked) return;

    var body = document.body;
    var restoreY = detailScrollY || 0;

    document.documentElement.classList.remove('mgr-detail-modal-open');
    if (body) body.classList.remove('mgr-detail-modal-open');

    detailScrollLocked = false;
    detailScrollY = 0;

    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, restoreY);
      window.requestAnimationFrame(function () {
        window.scrollTo(0, restoreY);
      });
    }
  }

  function makeAbsoluteUrl(value) {
    if (!value) return '';
    if (/^\/\//.test(value)) return window.location.protocol + value;
    return value;
  }

  function resolveAssetUrl(value, baseUrl) {
    if (!value) return '';

    if (value.indexOf('data:') === 0) return value;
    if (/^https?:\/\//i.test(value)) return value;
    if (/^\/\//.test(value)) return makeAbsoluteUrl(value);
    if (value.charAt(0) === '/') return value;

    try {
      return new URL(value, makeAbsoluteUrl(baseUrl || window.location.href)).toString();
    } catch (err) {
      return value;
    }
  }


  function resolveProductUrl(review) {
    if (!review) return '';

    var url = review.product_url || review.productUrl || review.product_link || review.productLink || review.url || '';

    if (!url && review.product_handle) {
      url = '/products/' + String(review.product_handle).replace(/^\/+|\/+$/g, '');
      if (review.variant_id) {
        url += '?variant=' + encodeURIComponent(review.variant_id);
      }
    }

    if (!url && review.productHandle) {
      url = '/products/' + String(review.productHandle).replace(/^\/+|\/+$/g, '');
      if (review.variantId) {
        url += '?variant=' + encodeURIComponent(review.variantId);
      }
    }

    if (!url) return '';

    url = String(url).trim();
    if (!url) return '';

    if (/^https?:\/\//i.test(url) || /^\/\//.test(url) || url.charAt(0) === '#') {
      return url;
    }

    if (url.charAt(0) !== '/') {
      url = '/' + url;
    }

    var languageMatch = window.location.pathname.match(/^\/(es|fr|de|it)(?=\/|$)/);
    if (languageMatch && url.indexOf('/' + languageMatch[1] + '/') !== 0 && url.indexOf('/products/') === 0) {
      return '/' + languageMatch[1] + url;
    }

    return url;
  }

  function getAssetVersionKey(url) {
    if (!url) return '';
    try {
      var parsed = new URL(makeAbsoluteUrl(url), window.location.href);
      return parsed.searchParams.get('v') || parsed.searchParams.get('_fd') || parsed.searchParams.get('shopify_theme_id') || '';
    } catch (err) {
      var match = String(url).match(/[?&](?:v|_fd|shopify_theme_id)=([^&#]+)/);
      return match ? match[1] : '';
    }
  }

  function addReviewCacheKey(url, sourceUrl) {
    if (!url) return url;
    var key = getAssetVersionKey(sourceUrl || getScriptSrcFallback() || window.location.href);
    if (!key) return url;

    try {
      var parsed = new URL(makeAbsoluteUrl(url), window.location.href);
      if (!parsed.searchParams.has('mgrv')) {
        parsed.searchParams.set('mgrv', key);
      }
      return parsed.toString();
    } catch (err) {
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'mgrv=' + encodeURIComponent(key);
    }
  }

  function safeJsonParse(value) {
    if (!value || typeof value !== 'string') return null;
    try {
      return JSON.parse(value);
    } catch (err) {
      return null;
    }
  }

  function getReviewsConfig() {
    return window.MEXICADA_GLOBAL_REVIEWS_CONFIG || window.MexicadaGlobalReviewsConfig || {};
  }

  function mergeBatchAssetUrls(target, source) {
    target = target || {};
    source = source || {};
    Object.keys(source).forEach(function (key) {
      if (source[key]) target[key] = source[key];
    });
    return target;
  }

  function getBatchAssetUrls(section) {
    var urls = {};
    var config = getReviewsConfig();

    if (config && config.batchAssetUrls) {
      mergeBatchAssetUrls(urls, config.batchAssetUrls);
    }

    if (section) {
      var parsed = safeJsonParse(section.getAttribute('data-batch-asset-urls'));
      if (parsed) mergeBatchAssetUrls(urls, parsed);
    }

    return urls;
  }

  function resolveReviewBatchUrl(batch, manifestUrl, batchAssetUrls) {
    if (!batch) return '';

    var explicitUrl = batch.url || batch.asset_url || batch.assetUrl || '';
    if (explicitUrl) return resolveAssetUrl(explicitUrl, manifestUrl);

    var file = batch.file || batch.path || batch.name || '';
    if (!file) return '';

    batchAssetUrls = batchAssetUrls || {};

    if (batchAssetUrls[file]) return resolveAssetUrl(batchAssetUrls[file], manifestUrl);

    var normalizedFile = String(file).replace(/^assets\//, '');
    if (batchAssetUrls[normalizedFile]) return resolveAssetUrl(batchAssetUrls[normalizedFile], manifestUrl);

    var assetKey = 'assets/' + normalizedFile;
    if (batchAssetUrls[assetKey]) return resolveAssetUrl(batchAssetUrls[assetKey], manifestUrl);

    return resolveAssetUrl(file, manifestUrl);
  }

  function normalizeStars(rating) {
    var number = parseInt(rating, 10);
    if (isNaN(number)) number = 5;
    return Math.max(1, Math.min(5, number));
  }

  function appendSvgStars(parent, rating) {
    var full = normalizeStars(rating);
    var svgNamespace = 'http://www.w3.org/2000/svg';

    parent.innerHTML = '';

    for (var index = 1; index <= 5; index += 1) {
      var star = document.createElementNS(svgNamespace, 'svg');
      star.setAttribute('viewBox', '0 0 24 24');
      star.setAttribute('aria-hidden', 'true');
      star.setAttribute('focusable', 'false');
      star.classList.add('mgr-card__star');
      star.style.color = '#a86a1f';
      star.style.fill = 'currentColor';

      var path = document.createElementNS(svgNamespace, 'path');
      path.setAttribute('d', 'M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.27 5.82 22 7 14.14l-5-4.87 6.91-1.01z');
      star.appendChild(path);

      if (index > full) {
        star.style.opacity = '.25';
      }

      parent.appendChild(star);
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getSectionText(selector, fallback) {
    var section = document.querySelector(SECTION_SELECTOR);
    var element = section ? section.querySelector(selector) : null;
    var text = element ? element.textContent.replace(/\s+/g, ' ').trim() : '';
    return text || fallback;
  }

  function formatDynamicReviewCount(value) {
    var number = parseInt(value, 10);
    if (!isFinite(number) || number < 0) number = 14764;

    var thousands = Math.floor(number / 1000);
    var remainder = number % 1000;
    var remainderText = String(remainder);
    while (remainderText.length < 3) remainderText = '0' + remainderText;

    return String(thousands) + ',' + remainderText;
  }

  function computeDynamicReviewCountValue() {
    var baseCount = 14764;
    var startEpoch = 1781654400;
    var nowEpoch = Math.floor(Date.now() / 1000);
    var daysElapsed = Math.floor((nowEpoch - startEpoch) / 86400);

    if (!isFinite(daysElapsed) || daysElapsed < 0) daysElapsed = 0;

    var count = baseCount;
    for (var day = 1; day <= daysElapsed; day += 1) {
      var seed = (day * 37) + 11;
      var increment = (seed % 16) + 10;
      count += increment;
    }

    return formatDynamicReviewCount(count);
  }

  function getReviewCountLabel() {
    var lang = refreshLanguage();
    if (lang === 'es') return 'reseñas';
    if (lang === 'fr') return 'avis';
    if (lang === 'de') return 'Bewertungen';
    if (lang === 'it') return 'recensioni';
    return 'Reviews';
  }

  function getSourceReviewCountElement() {
    var section = document.querySelector(SECTION_SELECTOR);
    if (!section) return null;
    return section.querySelector('.mexicada-global-reviews__count[data-mgr-dynamic-review-count]') ||
      section.querySelector('.mexicada-global-reviews__count');
  }

  function getDynamicReviewCountValue() {
    var source = getSourceReviewCountElement();
    var section = document.querySelector(SECTION_SELECTOR);
    var value = '';

    if (source) {
      value = source.getAttribute('data-mgr-dynamic-review-count-value') || '';
    }

    if (!value && section) {
      value = section.getAttribute('data-mgr-dynamic-review-count-value') || '';
    }

    return value || computeDynamicReviewCountValue();
  }

  function getDynamicReviewCountHtml() {
    var source = getSourceReviewCountElement();

    if (source && source.innerHTML && source.innerHTML.trim()) {
      return source.innerHTML;
    }

    var value = getDynamicReviewCountValue();
    return '<span class="notranslate gtranslate-no-translate gt-skip" translate="no">' +
      escapeHtml(value) +
      '</span> ' +
      escapeHtml(getReviewCountLabel());
  }

  function applyDynamicReviewCount(element) {
    if (!element) return;

    var value = getDynamicReviewCountValue();

    element.classList.add('notranslate');
    element.classList.add('gtranslate-no-translate');
    element.classList.add('gt-skip');
    element.setAttribute('translate', 'no');
    element.setAttribute('data-mgr-dynamic-review-count', '');
    element.setAttribute('data-mgr-dynamic-review-count-value', value);
    element.innerHTML = getDynamicReviewCountHtml();
  }

  function syncModalReviewCount() {
    if (!modalElement) return;
    var modalCount = modalElement.querySelector('.mgr-modal__summary .mexicada-global-reviews__count');
    applyDynamicReviewCount(modalCount);
  }

  function setStatus(statusElement, message) {
    if (!statusElement) return;
    if (!message) {
      statusElement.hidden = true;
      statusElement.textContent = '';
      return;
    }
    statusElement.hidden = false;
    statusElement.textContent = message;
  }

  /* Pull the first gallery image of the linked product and use it as the
     review thumbnail. Falls back silently to the existing demo thumb if the
     product cannot be loaded. Results are cached per product handle so the
     same product is only fetched once per page. */
  function getProductHandleFromUrl(url) {
    if (!url) return '';
    var match = String(url).match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function sizedShopifyImage(url, width) {
    if (!url) return url;
    if (url.indexOf('//') === 0) url = 'https:' + url;
    if (!width) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function fetchProductFirstImage(handle) {
    if (!handle) return Promise.resolve('');
    if (productImageCache[handle]) return productImageCache[handle];

    var request = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Product not found: ' + handle);
        return response.json();
      })
      .then(function (data) {
        var image = (data.images && data.images[0]) || data.featured_image || '';
        return image || '';
      })
      .catch(function () {
        return '';
      });

    productImageCache[handle] = request;
    return request;
  }

  function applyProductGalleryImage(imgEl, productUrl, width) {
    if (!imgEl || !productUrl) return;
    var handle = getProductHandleFromUrl(productUrl);
    if (!handle) return;

    imgEl.setAttribute('data-mgr-pending-handle', handle);
    fetchProductFirstImage(handle).then(function (image) {
      if (!image) return;
      // Guard against the element being reused for a different product
      // before this fetch resolved.
      if (imgEl.getAttribute('data-mgr-pending-handle') !== handle) return;
      imgEl.src = sizedShopifyImage(image, width || 200);
    });
  }

  function isLikelyVideoUrl(src) {
    if (!src) return false;
    src = String(src);
    return /\.(mp4|m4v|mov|webm|ogv|ogg)(\?|#|$)/i.test(src) ||
      /videodelivery\.net|cloudflarestream\.com/i.test(src);
  }

  function getCloudflareStreamId(item) {
    if (!item || typeof item !== 'object') return '';
    return item.cloudflare_stream_id || item.cloudflareStreamId || item.stream_id || item.streamId || item.video_uid || item.videoUid || item.uid || '';
  }

  function getCloudflareCustomerDomain(item) {
    if (!item || typeof item !== 'object') return '';
    return item.customer_domain_prefix || item.customerDomainPrefix || item.cloudflare_customer_domain || item.cloudflareCustomerDomain || '';
  }

  function getCloudflareHost(customerDomain) {
    if (!customerDomain) return '';
    var host = String(customerDomain).replace(/^https?:\/\//i, '').replace(/\/.*$/, '').replace(/\.$/, '');
    if (!host) return '';
    return host.indexOf('.') === -1 ? host + '.cloudflarestream.com' : host;
  }

  function getCloudflarePoster(streamId, customerDomain) {
    if (!streamId) return '';
    var host = getCloudflareHost(customerDomain);
    if (host) {
      return 'https://' + host + '/' + encodeURIComponent(streamId) + '/thumbnails/thumbnail.jpg?height=720';
    }
    return 'https://videodelivery.net/' + encodeURIComponent(streamId) + '/thumbnails/thumbnail.jpg?height=720';
  }

  function getCloudflareEmbedUrl(streamId, customerDomain, autoplay) {
    if (!streamId) return '';
    var query = '?controls=true&muted=true&preload=true' + (autoplay ? '&autoplay=true' : '');
    var host = getCloudflareHost(customerDomain);
    if (host) {
      return 'https://' + host + '/' + encodeURIComponent(streamId) + '/iframe' + query;
    }
    return 'https://iframe.videodelivery.net/' + encodeURIComponent(streamId) + query;
  }

  function ensureCloudflareStreamSdk(streamId, customerDomain) {
    if (!streamId || !document || !document.head) return;
    var host = getCloudflareHost(customerDomain) || 'embed.videodelivery.net';
    var key = host + ':' + streamId;
    if (cloudflareStreamScripts[key]) return;
    cloudflareStreamScripts[key] = true;

    var script = document.createElement('script');
    script.setAttribute('data-cfasync', 'false');
    script.defer = true;
    script.type = 'text/javascript';
    script.src = 'https://' + host + '/embed/sdk-iframe-integration.fla9.latest.js?video=' + encodeURIComponent(streamId);
    document.head.appendChild(script);
  }

  function isSmallDetailViewport() {
    if (window.matchMedia) return window.matchMedia('(max-width: 767px)').matches;
    return (window.innerWidth || document.documentElement.clientWidth || 1024) <= 767;
  }


  function parseDetailPositiveNumber(value) {
    if (value == null || value === '') return 0;
    if (typeof value === 'string') {
      var ratioMatch = value.match(/^\s*(\d+(?:\.\d+)?)\s*[:/]\s*(\d+(?:\.\d+)?)\s*$/);
      if (ratioMatch) {
        var rw = parseFloat(ratioMatch[1]);
        var rh = parseFloat(ratioMatch[2]);
        return rw > 0 && rh > 0 ? rw / rh : 0;
      }
    }
    var number = parseFloat(value);
    return isFinite(number) && number > 0 ? number : 0;
  }

  function getDetailItemAspectRatio(item) {
    if (!item || typeof item !== 'object') return 0;
    var direct = parseDetailPositiveNumber(item.aspect_ratio || item.aspectRatio || item.ratio || item.media_ratio || item.mediaRatio);
    if (direct > 0) return direct;

    var width = parseDetailPositiveNumber(item.width || item.w || item.video_width || item.videoWidth || item.image_width || item.imageWidth || item.naturalWidth);
    var height = parseDetailPositiveNumber(item.height || item.h || item.video_height || item.videoHeight || item.image_height || item.imageHeight || item.naturalHeight);
    if (width > 0 && height > 0) return width / height;

    if (item.type === 'video' && Array.isArray(item.sources) && item.sources.length) {
      for (var i = 0; i < item.sources.length; i += 1) {
        var source = item.sources[i] || {};
        width = parseDetailPositiveNumber(source.width || source.w || source.video_width || source.videoWidth);
        height = parseDetailPositiveNumber(source.height || source.h || source.video_height || source.videoHeight);
        if (width > 0 && height > 0) return width / height;
      }
    }

    return 0;
  }

  function getActiveDetailMediaAspectRatio() {
    if (!detailModalElement || !currentDetailImages || !currentDetailImages.length) return 0;
    var activeSlide = detailModalElement.querySelector('[data-mgr-detail-slide].is-active') ||
      detailModalElement.querySelector('[data-mgr-detail-slide="' + String(currentDetailImageIndex || 0) + '"]');
    var item = currentDetailImages[currentDetailImageIndex || 0];

    if (activeSlide) {
      var video = activeSlide.querySelector('[data-mgr-native-video]');
      if (video && video.videoWidth > 0 && video.videoHeight > 0) return video.videoWidth / video.videoHeight;

      var image = activeSlide.querySelector('img.mgr-review-detail__image');
      if (image && image.naturalWidth > 0 && image.naturalHeight > 0) return image.naturalWidth / image.naturalHeight;
    }

    return getDetailItemAspectRatio(item);
  }

  function clearDetailDynamicMediaSizing() {
    if (!detailModalElement) return;
    var panel = detailModalElement.querySelector('.mgr-review-detail__panel');
    if (!panel) return;
    panel.style.removeProperty('--mgr-detail-panel-width');
    panel.style.removeProperty('--mgr-detail-panel-height');
    panel.style.removeProperty('--mgr-detail-media-width');
    panel.style.removeProperty('--mgr-detail-media-height');
    panel.style.removeProperty('--mgr-detail-content-width');
  }

  function applyDetailDynamicMediaSizing() {
    if (!detailModalElement || detailModalElement.hidden || !currentDetailImages || !currentDetailImages.length) return;

    var panel = detailModalElement.querySelector('.mgr-review-detail__panel');
    if (!panel) return;

    if (isSmallDetailViewport()) {
      clearDetailDynamicMediaSizing();
      setDetailTrackPosition(0, false);
      return;
    }

    var aspect = getActiveDetailMediaAspectRatio();
    if (!aspect || !isFinite(aspect) || aspect <= 0) return;

    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 1200;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 800;
    var horizontalPadding = Math.max(56, Math.min(72, Math.round(viewportWidth * 0.045)));
    var verticalPadding = 36;
    var availableWidth = Math.max(640, viewportWidth - horizontalPadding);
    var availableHeight = Math.max(320, viewportHeight - verticalPadding);

    var contentWidth = Math.round(Math.min(520, Math.max(390, availableWidth * 0.42)));
    var maxMediaWidth = Math.max(260, availableWidth - contentWidth);
    var mediaHeight = availableHeight;
    var mediaWidth = Math.round(mediaHeight * aspect);

    if (mediaWidth > maxMediaWidth) {
      mediaWidth = Math.round(maxMediaWidth);
      mediaHeight = Math.round(mediaWidth / aspect);
    }

    // Avoid a tiny media column on unusual uploads while still matching the
    // real image/video aspect ratio. If this branch runs, height shrinks/grows
    // from the width rather than stretching the media inside a fixed black box.
    var minMediaWidth = Math.min(360, Math.max(260, availableWidth - contentWidth));
    if (mediaWidth < minMediaWidth && maxMediaWidth >= minMediaWidth) {
      mediaWidth = Math.round(minMediaWidth);
      mediaHeight = Math.round(mediaWidth / aspect);
      if (mediaHeight > availableHeight) {
        mediaHeight = Math.round(availableHeight);
        mediaWidth = Math.round(mediaHeight * aspect);
      }
    }

    var panelWidth = Math.round(mediaWidth + contentWidth);
    var panelHeight = Math.round(mediaHeight);

    panel.style.setProperty('--mgr-detail-media-width', mediaWidth + 'px');
    panel.style.setProperty('--mgr-detail-media-height', panelHeight + 'px');
    panel.style.setProperty('--mgr-detail-content-width', contentWidth + 'px');
    panel.style.setProperty('--mgr-detail-panel-width', panelWidth + 'px');
    panel.style.setProperty('--mgr-detail-panel-height', panelHeight + 'px');

    setDetailTrackPosition(0, false);
  }

  function getDetailTrack() {
    return detailModalElement ? detailModalElement.querySelector('[data-mgr-detail-track]') : null;
  }

  function getDetailVisibleMediaElements() {
    var elements = [];
    var track = getDetailTrack();
    if (track) elements.push(track);
    return elements;
  }

  function getDetailTrackSignature() {
    if (!currentDetailImages || !currentDetailImages.length) return '';
    return currentDetailImages.map(function (item) {
      if (!item) return 'x';
      return [item.type || 'image', item.url || '', item.embedUrl || '', item.streamId || '', item.poster || ''].join('|');
    }).join('||');
  }

  function setDetailTrackPosition(offsetPx, animate) {
    var track = getDetailTrack();
    if (!track) return;

    var index = currentDetailImageIndex || 0;
    var offset = Number(offsetPx) || 0;
    var viewport = track.parentElement || track;
    var viewportWidth = viewport.getBoundingClientRect ? viewport.getBoundingClientRect().width : viewport.clientWidth;

    // Use pixel movement instead of percentage movement. A percentage transform is
    // measured against the transformed element itself, which made the slider unreliable
    // once the track had multiple 100%-wide slides. Pixel movement keeps the slides
    // physically attached and makes mobile drag follow the finger exactly.
    if (!viewportWidth || viewportWidth < 1) {
      viewportWidth = window.innerWidth || document.documentElement.clientWidth || 1;
    }

    var x = (-index * viewportWidth) + offset;
    track.style.setProperty('transition', animate ? 'transform 260ms cubic-bezier(.22,.61,.36,1)' : 'none', 'important');
    track.style.setProperty('transform', 'translate3d(' + x + 'px, 0, 0)', 'important');
  }

  function setDetailMediaDragOffset(offsetPx, animate) {
    setDetailTrackPosition(offsetPx, animate);
  }

  function clearDetailMediaDragOffset() {
    setDetailTrackPosition(0, false);
  }

  function runDetailSlideAnimation(direction) {
    setDetailTrackPosition(0, true);
  }

  function pauseAllDetailNativeVideos(exceptVideo) {
    if (!detailModalElement) return;
    Array.prototype.forEach.call(detailModalElement.querySelectorAll('[data-mgr-native-video]'), function (video) {
      if (exceptVideo && video === exceptVideo) return;
      if (video && typeof video.pause === 'function') {
        try { video.pause(); } catch (err) {}
      }
    });
  }

  function playActiveDetailVideoIfNeeded() {
    if (!detailModalElement) return;
    var activeSlide = detailModalElement.querySelector('[data-mgr-detail-slide].is-active');
    if (!activeSlide) return;
    var video = activeSlide.querySelector('[data-mgr-native-video]');
    if (!video) return;
    try {
      var playPromise = video.play && video.play();
      if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
    } catch (err) {}
  }

  function getReviewMedia(review, baseUrl) {
    var mediaItems = [];
    var seen = {};
    var rawMedia = [];

    if (!review) return mediaItems;

    if (Array.isArray(review.media)) rawMedia = rawMedia.concat(review.media);
    if (Array.isArray(review.images)) rawMedia = rawMedia.concat(review.images);
    if (Array.isArray(review.photos)) rawMedia = rawMedia.concat(review.photos);
    if (Array.isArray(review.videos)) rawMedia = rawMedia.concat(review.videos);
    if (Array.isArray(review.review_images)) rawMedia = rawMedia.concat(review.review_images);
    if (Array.isArray(review.reviewImages)) rawMedia = rawMedia.concat(review.reviewImages);
    if (Array.isArray(review.review_videos)) rawMedia = rawMedia.concat(review.review_videos);
    if (Array.isArray(review.reviewVideos)) rawMedia = rawMedia.concat(review.reviewVideos);

    if (!rawMedia.length && review.media && typeof review.media === 'string') rawMedia.push(review.media);
    if (!rawMedia.length && review.images && typeof review.images === 'string') rawMedia.push(review.images);
    if (!rawMedia.length && review.photos && typeof review.photos === 'string') rawMedia.push(review.photos);
    if (!rawMedia.length && review.video && typeof review.video === 'string') rawMedia.push({ type: 'video', src: review.video });
    if (!rawMedia.length && review.video_url && typeof review.video_url === 'string') rawMedia.push({ type: 'video', src: review.video_url });
    if (!rawMedia.length && review.videoUrl && typeof review.videoUrl === 'string') rawMedia.push({ type: 'video', src: review.videoUrl });

    if (review.cloudflare_stream_id || review.cloudflareStreamId || review.stream_id || review.streamId) {
      rawMedia.unshift({
        type: 'video',
        cloudflare_stream_id: review.cloudflare_stream_id || review.cloudflareStreamId || review.stream_id || review.streamId,
        customer_domain_prefix: review.customer_domain_prefix || review.customerDomainPrefix || review.cloudflare_customer_domain || review.cloudflareCustomerDomain || '',
        poster: review.poster || review.video_poster || review.videoPoster || review.thumbnail || review.thumb || ''
      });
    }

    if (review.image) {
      rawMedia.unshift({
        type: 'image',
        src: review.image,
        alt: getReviewField(review, 'image_alt', '')
      });
    }

    rawMedia.forEach(function (item, index) {
      var src = '';
      var poster = '';
      var thumbnail = '';
      var alt = '';
      var type = '';
      var embedUrl = '';
      var streamId = '';
      var customerDomain = '';
      var cardPlayOverlay = true;
      var sources = [];
      var declaredQualities = [];

      if (typeof item === 'string') {
        src = item;
        type = isLikelyVideoUrl(src) ? 'video' : 'image';
      } else if (item && typeof item === 'object') {
        src = item.src || item.url || item.video || item.video_url || item.videoUrl || item.image || item.asset || item.path || item.file || item.preview || '';
        sources = normalizeVideoSourceList(item.sources || item.video_sources || item.videoSources || item.renditions || item.quality_sources || item.qualitySources || null, baseUrl);
        declaredQualities = normalizeVideoQualityList(item.qualities || item.available_qualities || item.availableQualities || item.resolutions || item.quality_options || item.qualityOptions || null);
        if (!src && sources.length) src = sources[0].url || '';
        poster = item.poster || item.video_poster || item.videoPoster || item.thumbnail || item.thumb || item.preview_image || item.previewImage || '';
        thumbnail = item.thumbnail || item.thumb || item.poster || item.preview_image || item.previewImage || '';
        alt = item.alt || item.image_alt || item.imageAlt || item.video_alt || item.videoAlt || item.title || '';
        type = String(item.type || item.kind || '').toLowerCase();
        streamId = getCloudflareStreamId(item);
        customerDomain = getCloudflareCustomerDomain(item);
        embedUrl = item.embed || item.embed_url || item.embedUrl || item.iframe || item.iframe_url || item.iframeUrl || '';
        if (item.card_play_overlay === false || item.cardPlayOverlay === false || item.show_play_badge === false || item.showPlayBadge === false) {
          cardPlayOverlay = false;
        }
      }

      if (!type) type = (streamId || embedUrl || isLikelyVideoUrl(src)) ? 'video' : 'image';
      if (type === 'photo') type = 'image';
      if (type !== 'video') type = 'image';

      if (type === 'video') {
        if (streamId && !poster) poster = getCloudflarePoster(streamId, customerDomain);
        if (streamId && !thumbnail) thumbnail = poster;
        if (streamId && !embedUrl) embedUrl = getCloudflareEmbedUrl(streamId, customerDomain, true);
        if (poster) poster = resolveAssetUrl(String(poster), baseUrl);
        if (thumbnail) thumbnail = resolveAssetUrl(String(thumbnail), baseUrl);
        if (src) src = resolveAssetUrl(String(src), baseUrl);
        if (embedUrl) embedUrl = resolveAssetUrl(String(embedUrl), baseUrl);

        if (!src && !embedUrl && !streamId) return;

        var videoKey = 'video:' + (embedUrl || src || streamId);
        if (seen[videoKey]) return;
        seen[videoKey] = true;

        mediaItems.push({
          type: 'video',
          url: src,
          embedUrl: embedUrl,
          poster: poster,
          thumbnail: thumbnail || poster,
          streamId: streamId,
          customerDomain: customerDomain,
          sources: sources,
          qualities: declaredQualities,
          cardPlayOverlay: cardPlayOverlay,
          alt: alt || getReviewField(review, 'video_alt', '') || getReviewField(review, 'image_alt', '') || getReviewField(review, 'product_name', t('customerReviewPhoto')) || t('customerReviewPhoto') + ' ' + (index + 1)
        });
        return;
      }

      if (!src) return;

      var url = resolveAssetUrl(String(src), baseUrl);
      if (!url || seen[url]) return;
      seen[url] = true;

      mediaItems.push({
        type: 'image',
        url: url,
        alt: alt || getReviewField(review, 'image_alt', '') || getReviewField(review, 'product_name', t('customerReviewPhoto')) || t('customerReviewPhoto') + ' ' + (index + 1)
      });
    });

    return mediaItems;
  }

  function getReviewImages(review, baseUrl) {
    return getReviewMedia(review, baseUrl);
  }

  function getMediaThumbUrl(item) {
    if (!item) return '';
    if (item.type === 'video') return item.thumbnail || item.poster || '';
    return item.thumbnail || item.poster || item.url || '';
  }

  function createVideoPlayIcon(className) {
    var icon = document.createElement('span');
    icon.className = className || 'mgr-video-play-badge';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="currentColor" focusable="false"><path d="M14 15.06V33a2 2 0 0 0 2.93 1.77l17.09-8.97a2 2 0 0 0 0-3.54L16.93 13.3A2 2 0 0 0 14 15.06z"></path></svg>';
    return icon;
  }

  function createMultiPhotoBadge(review, photoCount) {
    if (!photoCount || photoCount < 2) return null;

    var badge = document.createElement('span');
    var reviewId = review && review.id ? String(review.id).replace(/[^a-zA-Z0-9_-]/g, '-') : 'customer-photo';
    badge.className = 'multi-photo-badge mgr-card__multi-photo-badge';
    badge.setAttribute('data-testid', 'review-' + reviewId + '-multi-photo-badge');
    badge.setAttribute('aria-label', String(photoCount) + ' review photos');
    badge.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="m3.122 11.13 1.455-1.455 4.002 4.002 2.547-2.547 2.183 2.183V6.69H3.122v4.439Zm-.728-5.894h11.642a.727.727 0 0 1 .728.728v11.642a.727.727 0 0 1-.728.727H2.394a.727.727 0 0 1-.727-.727V5.964a.728.728 0 0 1 .727-.728Zm8.368 5.093a1.091 1.091 0 1 1 0-2.182 1.091 1.091 0 0 1 0 2.182Z"></path><path d="m15.492 9.364 1.17 1.43.658-6.59L7.184 3.192l-.132 1.317H5.59l.219-2.186a.728.728 0 0 1 .796-.652l11.584 1.16a.728.728 0 0 1 .652.796L17.682 15.21a.728.728 0 0 1-.796.651l-1.394-.139V9.364Z"></path></svg>+' + String(photoCount - 1);
    return badge;
  }

  function createReviewCard(review, baseUrl) {
    refreshLanguage();
    var article = document.createElement('article');
    article.className = 'mgr-card';
    article.setAttribute('data-mgr-lang', refreshLanguage());
    if (review.id) article.setAttribute('data-review-id', review.id);

    var resolvedProductUrl = resolveProductUrl(review);
    if (resolvedProductUrl) {
      article.setAttribute('data-product-url', resolvedProductUrl);
    }

    var reviewImages = getReviewImages(review, baseUrl);
    var firstMedia = reviewImages.length ? reviewImages[0] : null;
    var imageUrl = getMediaThumbUrl(firstMedia);
    var hasNativeVideoPreview = firstMedia && firstMedia.type === 'video' && firstMedia.url && !imageUrl;
    if (imageUrl || hasNativeVideoPreview) {
      var media = document.createElement('div');
      media.className = 'mgr-card__media mgr-card__media--pending';
      if (firstMedia && firstMedia.type === 'video') {
        media.className += ' mgr-card__media--video';
      }

      var releasePendingMedia = function () {
        if (media && media.classList) media.classList.remove('mgr-card__media--pending');
      };

      if (hasNativeVideoPreview) {
        var video = document.createElement('video');
        video.className = 'mgr-card__image mgr-card__video-preview';
        video.muted = true;
        video.playsInline = true;
        video.preload = 'metadata';
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('preload', 'metadata');
        video.setAttribute('aria-label', firstMedia.alt || getReviewField(review, 'image_alt', getReviewField(review, 'product_name', t('customerReviewPhoto'))));
        if (firstMedia.poster) video.poster = firstMedia.poster;
        if (isIOSLikeDevice() && !firstMedia.poster) {
          video.src = getFirstFrameVideoUrl(firstMedia.url);
          primeIOSVideoThumbnail(video, firstMedia.url, releasePendingMedia);
        } else {
          video.src = firstMedia.url;
          video.addEventListener('loadedmetadata', releasePendingMedia, { once: true });
          video.addEventListener('loadeddata', releasePendingMedia, { once: true });
          video.addEventListener('error', releasePendingMedia, { once: true });
          window.setTimeout(releasePendingMedia, 2600);
        }
        media.appendChild(video);
      } else {
        var image = document.createElement('img');
        image.className = 'mgr-card__image';
        image.loading = 'lazy';
        image.decoding = 'async';
        image.src = imageUrl;
        image.alt = firstMedia.alt || getReviewField(review, 'image_alt', getReviewField(review, 'product_name', t('customerReviewPhoto')));
        if (image.complete && image.naturalWidth) {
          releasePendingMedia();
        } else {
          image.addEventListener('load', releasePendingMedia, { once: true });
          image.addEventListener('error', releasePendingMedia, { once: true });
          window.setTimeout(releasePendingMedia, 2600);
        }
        media.appendChild(image);
      }

      if (firstMedia && firstMedia.type === 'video' && firstMedia.cardPlayOverlay !== false) {
        media.appendChild(createVideoPlayIcon('mgr-video-play-badge mgr-card__video-play'));
      }

      var multiPhotoBadge = createMultiPhotoBadge(review, reviewImages.length);
      if (multiPhotoBadge) media.appendChild(multiPhotoBadge);

      article.appendChild(media);
    }

    var body = document.createElement('div');
    body.className = 'mgr-card__body';

    var nameRow = document.createElement('div');
    nameRow.className = 'mgr-card__name-row';

    var name = document.createElement('span');
    name.className = 'mgr-card__name';
    name.textContent = review.name || t('verifiedCustomer');
    nameRow.appendChild(name);

    if (review.verified !== false) {
      var verified = document.createElement('span');
      verified.className = 'mgr-card__verified';
      verified.setAttribute('aria-label', t('verifiedPurchase'));
      verified.setAttribute('role', 'img');
      nameRow.appendChild(verified);
    }

    body.appendChild(nameRow);

    var stars = document.createElement('div');
    stars.className = 'mgr-card__stars';
    stars.setAttribute('aria-label', t('outOfFiveStars').replace('{rating}', normalizeStars(review.rating)));
    appendSvgStars(stars, review.rating);
    body.appendChild(stars);

    var localizedReviewText = getReviewField(review, 'text', '');
    if (localizedReviewText) {
      var text = document.createElement('p');
      text.className = 'mgr-card__text';
      setLocalizedText(text, localizedReviewText, hasReviewTranslation(review, 'text'));
      body.appendChild(text);
    }

    article.appendChild(body);

    var localizedProductName = getReviewField(review, 'product_name', '');
    if (localizedProductName || review.product_thumb || resolvedProductUrl) {
      var product = document.createElement('div');
      product.className = 'mgr-card__product';
      if (resolvedProductUrl) {
        product.setAttribute('data-product-url', resolvedProductUrl);
      }

      var thumbSource = review.product_thumb || (resolvedProductUrl ? 'mexicada-review-thumb.svg' : '');
      var thumbUrl = resolveAssetUrl(thumbSource, baseUrl);
      if (thumbUrl) {
        var thumb = document.createElement('img');
        thumb.className = 'mgr-card__product-image';
        thumb.loading = 'lazy';
        thumb.decoding = 'async';
        thumb.src = thumbUrl;
        thumb.alt = localizedProductName || t('reviewedProduct');
        product.appendChild(thumb);
        applyProductGalleryImage(thumb, resolvedProductUrl, 200);
      }

      if (localizedProductName) {
        var productName = document.createElement('div');
        productName.className = 'mgr-card__product-name';
        setLocalizedText(productName, localizedProductName, hasReviewTranslation(review, 'product_name'));
        product.appendChild(productName);
      }

      article.appendChild(product);
    }

    article.setAttribute('role', 'button');
    article.setAttribute('tabindex', '0');
    article.setAttribute('aria-label', t('openReviewFrom').replace('{name}', review.name || t('verifiedCustomer')));
    var storedReview = {};
    Object.keys(review || {}).forEach(function (key) {
      storedReview[key] = review[key];
    });
    if (resolvedProductUrl) {
      storedReview._resolved_product_url = resolvedProductUrl;
    }

    reviewDataByCard.set(article, {
      review: storedReview,
      baseUrl: baseUrl || window.location.href,
      productUrl: resolvedProductUrl || ''
    });

    return article;
  }

  function createReviewLoader(options) {
    var manifestUrl = options.manifestUrl;
    var grid = options.grid;
    var button = options.button;
    var status = options.status;
    var batchAssetUrls = options.batchAssetUrls || getBatchAssetUrls();
    var useWindowScrollAnchor = options.useWindowScrollAnchor !== false;
    var scrollContainer = options.scrollContainer || null;

    var state = {
      manifest: null,
      nextBatchIndex: 0,
      loading: false,
      started: false
    };

    function updateButton() {
      if (!button) return;
      if (!state.manifest || !Array.isArray(state.manifest.batches)) {
        button.hidden = true;
        return;
      }
      button.hidden = state.nextBatchIndex >= state.manifest.batches.length;
    }

    function loadManifest() {
      if (state.manifest) return Promise.resolve(state.manifest);

      return fetch(manifestUrl, { credentials: 'same-origin', cache: 'default' })
        .then(function (response) {
          if (!response.ok) throw new Error('Could not load review manifest.');
          return response.json();
        })
        .then(function (manifest) {
          state.manifest = manifest || { batches: [] };
          updateButton();
          return state.manifest;
        });
    }

    function loadNextBatch(options) {
      options = options || {};
      if (state.loading) return Promise.resolve();
      var preservedScrollPosition = options.preserveScroll ? (options.scrollPosition || getReviewScrollPosition(scrollContainer)) : null;
      var removeScrollLockClass = false;

      if (preservedScrollPosition && document.documentElement && document.documentElement.classList) {
        document.documentElement.classList.add('mgr-review-load-more-locking');
        if (scrollContainer && scrollContainer.classList) scrollContainer.classList.add('mgr-review-load-more-locking');
        removeScrollLockClass = true;
      }

      state.loading = true;
      if (button) button.disabled = true;
      setStatus(status, state.started ? '' : 'Loading reviews…');

      return loadManifest()
        .then(function (manifest) {
          var batches = Array.isArray(manifest.batches) ? manifest.batches : [];
          var batch = batches[state.nextBatchIndex];

          if (!batch || !(batch.file || batch.url || batch.asset_url || batch.assetUrl)) {
            setStatus(status, '');
            updateButton();
            return null;
          }

          var batchUrl = resolveReviewBatchUrl(batch, manifestUrl, batchAssetUrls);
          if (!getAssetVersionKey(batchUrl)) {
            batchUrl = addReviewCacheKey(batchUrl, manifestUrl);
          }

          return fetch(batchUrl, { credentials: 'same-origin', cache: 'default' })
            .then(function (response) {
              if (!response.ok) throw new Error('Could not load review batch.');
              return response.json();
            })
            .then(function (reviews) {
              if (!Array.isArray(reviews)) reviews = reviews && reviews.reviews ? reviews.reviews : [];

              var fragment = document.createDocumentFragment();
              var newCards = [];
              var shouldFadeLoadedCards = !!(options.preserveScroll && state.started);
              reviews.forEach(function (review) {
                var card = createReviewCard(review || {}, batchUrl);
                if (shouldFadeLoadedCards && card && card.classList) {
                  card.classList.add('is-mgr-loadmore-fade-pending');
                }
                newCards.push(card);
                if (!shouldFadeLoadedCards) {
                  fragment.appendChild(card);
                }
              });

              var appendAndLayout = function () {
                if (shouldFadeLoadedCards) {
                  newCards.forEach(function (card) {
                    fragment.appendChild(card);
                  });
                }

                grid.appendChild(fragment);
                arrangeReviewMasonryGrid(grid, newCards);
                if (preservedScrollPosition) settleReviewScrollPosition(scrollContainer, preservedScrollPosition);

                if (shouldFadeLoadedCards) {
                  // Reveal AFTER the new media settles, not before.
                  //
                  // The cards are already in the DOM and already reserve their
                  // square placeholder space (mgr-card__media--pending), so the
                  // button responds instantly and the existing wall does not
                  // move — only the click frame's cheap work runs now.
                  //
                  // The visible jump used to come later: each new photo/video
                  // finishing download releases its square placeholder for the
                  // real image height, which changes that card's row span and
                  // reshuffles the new batch. Revealing immediately (the old
                  // behaviour) meant the user watched that square -> real-height
                  // mutation. Instead we keep the new cards transparent, eagerly
                  // decode their media off the click frame, re-run the span
                  // measurement once the heights are real, and only then fade
                  // the batch in — so they appear already settled.
                  //
                  // This does NOT reintroduce the old "wait before append" lag:
                  // append/placement happen immediately and state.loading is
                  // released right away (the wait below is a detached promise).
                  // waitForReviewCardMedia resolves per element on load or after
                  // an 850ms cap, and also flips the new images to eager so
                  // below-the-fold cards do not sit as squares waiting on scroll.
                  waitForReviewCardMedia(newCards).then(function () {
                    arrangeReviewMasonryGrid(grid, newCards);
                    if (preservedScrollPosition) settleReviewScrollPosition(scrollContainer, preservedScrollPosition);
                    revealLoadedReviewCards(newCards);
                  });
                }

                state.nextBatchIndex += 1;
                state.started = true;
                setStatus(status, '');
                updateButton();
              };

              appendAndLayout();
            });
        })
        .catch(function (error) {
          if (window.console && typeof window.console.warn === 'function') {
            window.console.warn('[Mexicada reviews] Could not load reviews:', error);
          }
          setStatus(status, 'Reviews could not load right now.');
        })
        .finally(function () {
          state.loading = false;
          if (button) button.disabled = false;
          if (preservedScrollPosition) settleReviewScrollPosition(scrollContainer, preservedScrollPosition);
          if (removeScrollLockClass && document.documentElement && document.documentElement.classList) {
            window.setTimeout(function () {
              document.documentElement.classList.remove('mgr-review-load-more-locking');
              if (scrollContainer && scrollContainer.classList) scrollContainer.classList.remove('mgr-review-load-more-locking');
            }, 420);
          }
        });
    }

    if (button) {
      var pendingLoadMoreScrollPosition = null;
      var rememberLoadMoreScrollPosition = function () {
        pendingLoadMoreScrollPosition = getReviewScrollPosition(scrollContainer);
      };

      if (window.PointerEvent) {
        button.addEventListener('pointerdown', rememberLoadMoreScrollPosition, { passive: true });
      } else {
        button.addEventListener('mousedown', rememberLoadMoreScrollPosition, { passive: true });
        button.addEventListener('touchstart', rememberLoadMoreScrollPosition, { passive: true });
      }

      button.addEventListener('click', function (event) {
        var preservedScrollPosition = pendingLoadMoreScrollPosition || getReviewScrollPosition(scrollContainer);
        pendingLoadMoreScrollPosition = null;
        event.preventDefault();
        event.stopPropagation();
        if (typeof button.blur === 'function') button.blur();
        loadNextBatch({
          preserveScroll: true,
          scrollPosition: preservedScrollPosition
        });
      });
    }

    return {
      state: state,
      loadNextBatch: loadNextBatch,
      updateButton: updateButton
    };
  }

  function getScriptSrcFallback() {
    if (SCRIPT_SRC) return SCRIPT_SRC;

    var scripts = Array.prototype.slice.call(document.querySelectorAll('script[src]'));
    var match = scripts.find(function (script) {
      return /mexicada-global-reviews.*\.js/i.test(script.getAttribute('src') || '');
    });

    return match ? match.src : '';
  }

  function getManifestUrl() {
    var section = document.querySelector(SECTION_SELECTOR);
    var sectionManifest = section ? section.getAttribute('data-manifest-url') : '';
    if (sectionManifest) return sectionManifest;

    var explicitManifest = document.querySelector('[data-mgr-manifest-url]');
    if (explicitManifest && explicitManifest.getAttribute('data-mgr-manifest-url')) {
      return explicitManifest.getAttribute('data-mgr-manifest-url');
    }

    var config = getReviewsConfig();
    if (config && config.manifestUrl) return config.manifestUrl;

    var scriptSrc = getScriptSrcFallback();
    if (!scriptSrc) return '';

    try {
      var url = new URL(scriptSrc, window.location.href);
      url.pathname = url.pathname.replace(/[^/]+$/, 'mexicada-global-reviews-manifest.json');
      url.search = '';
      url.hash = '';
      return url.toString();
    } catch (err) {
      return scriptSrc.replace(/[^/?#]+(?:\?[^#]*)?(?:#.*)?$/, 'mexicada-global-reviews-manifest.json');
    }
  }

  function initSection(section) {
    if (!section || initializedSections.has(section)) return;
    initializedSections.add(section);

    var manifestUrl = section.getAttribute('data-manifest-url');
    var grid = section.querySelector('[data-mgr-grid]');
    var button = section.querySelector('[data-mgr-load-more]');
    var status = section.querySelector('[data-mgr-status]');
    var batchAssetUrls = getBatchAssetUrls(section);

    if (!manifestUrl || !grid || !button) return;

    var loader = createReviewLoader({
      manifestUrl: manifestUrl,
      batchAssetUrls: batchAssetUrls,
      grid: grid,
      button: button,
      status: status,
      useWindowScrollAnchor: true
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            observer.disconnect();
            loader.loadNextBatch();
          }
        });
      }, { rootMargin: '450px 0px' });

      observer.observe(section);
    } else {
      loader.loadNextBatch();
    }
  }

  function getFocusableElements(container) {
    return Array.prototype.slice.call(container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) {
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    });
  }

  function closeReviewsModal() {
    if (!modalElement || modalElement.hidden) return;

    var finishClose = function () {
      modalCloseTimer = null;
      modalElement.hidden = true;
      modalElement.classList.remove('is-closing', 'is-open');
      document.documentElement.classList.remove('mgr-modal-open');
      if (document.body) document.body.classList.remove('mgr-modal-open');

      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus({ preventScroll: true });
      }
    };

    if (modalAnimationFrame) {
      window.cancelAnimationFrame(modalAnimationFrame);
      modalAnimationFrame = null;
    }
    if (modalCloseTimer) {
      window.clearTimeout(modalCloseTimer);
      modalCloseTimer = null;
    }

    modalElement.classList.remove('is-open');
    modalElement.classList.add('is-closing');

    var prefersReducedMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
      finishClose();
      return;
    }

    // Keep in sync with the 0.24s transition in mexicada-global-reviews.css.
    modalCloseTimer = window.setTimeout(finishClose, 240);
  }

  function createReviewsModal(manifestUrl, batchAssetUrls) {
    var modalTitle = getSectionText('.mexicada-global-reviews__title', 'La Familia Mexicada');
    var modalSubtitle = getSectionText('.mexicada-global-reviews__subtitle', 'From our gente, across the collection');
    var modalCountHtml = getDynamicReviewCountHtml();
    var modalCountValue = getDynamicReviewCountValue();

    var modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.className = 'mgr-modal';
    modal.hidden = true;
    modal.innerHTML = [
      '<div class="mgr-modal__overlay" data-mgr-modal-close></div>',
      '<div class="mgr-modal__panel" role="dialog" aria-modal="true" aria-labelledby="mgr-modal-title" tabindex="-1">',
        '<div class="mgr-modal__header">',
          '<div>',
            '<h2 id="mgr-modal-title" class="mgr-modal__title">' + escapeHtml(modalTitle) + '</h2>',
            '<p class="mgr-modal__subtitle">' + escapeHtml(modalSubtitle) + '</p>',
            '<div class="mexicada-global-reviews__summary mgr-modal__summary" aria-label="Average rating 5 out of 5">',
              '<span class="mexicada-global-reviews__stars mgr-modal__header-stars" aria-hidden="true"></span>',
              '<span class="mexicada-global-reviews__count notranslate gtranslate-no-translate gt-skip" translate="no" data-mgr-dynamic-review-count data-mgr-dynamic-review-count-value="' + escapeHtml(modalCountValue) + '">' + modalCountHtml + '</span>',
            '</div>',
          '</div>',
          '<button type="button" class="mgr-modal__close" data-mgr-modal-close aria-label="Close reviews">×</button>',
        '</div>',
        '<div class="mgr-modal__body">',
          '<div class="mexicada-global-reviews__status mgr-modal__status" data-mgr-modal-status hidden></div>',
          '<div class="mexicada-global-reviews__grid mgr-modal__grid" data-mgr-modal-grid aria-live="polite"></div>',
          '<button type="button" class="mexicada-global-reviews__load-more mgr-modal__load-more" data-mgr-modal-load-more hidden>Show more reviews</button>',
        '</div>',
      '</div>'
    ].join('');

    document.body.appendChild(modal);
    updateStaticReviewCopy(modal);
    syncModalReviewCount();

    var headerStars = modal.querySelector('.mgr-modal__header-stars');
    if (headerStars) appendSvgStars(headerStars, 5);

    var grid = modal.querySelector('[data-mgr-modal-grid]');
    var button = modal.querySelector('[data-mgr-modal-load-more]');
    var status = modal.querySelector('[data-mgr-modal-status]');

    modalLoader = createReviewLoader({
      manifestUrl: manifestUrl,
      batchAssetUrls: batchAssetUrls || getBatchAssetUrls(),
      grid: grid,
      button: button,
      status: status,
      useWindowScrollAnchor: false,
      scrollContainer: modal.querySelector('.mgr-modal__body')
    });

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-mgr-modal-close]')) {
        closeReviewsModal();
      }
    });

    var swipeSurface = modal.querySelector('[data-mgr-detail-image-wrap]');
    if (swipeSurface) {
      swipeSurface.addEventListener('pointerdown', function (event) {
        if (!isSmallDetailViewport() || currentDetailImages.length < 2) return;
        if (event.button && event.button !== 0) return;
        if (event.target.closest('button, a, input, select, textarea, [data-mgr-detail-thumbs], [data-mgr-detail-close]')) return;
        detailSwipeState = {
          id: event.pointerId,
          startX: event.clientX,
          startY: event.clientY,
          deltaX: 0,
          deltaY: 0,
          dragging: false,
          axis: null
        };
        // Wait until the gesture is clearly horizontal before capturing.
      });

      swipeSurface.addEventListener('pointermove', function (event) {
        if (!detailSwipeState || detailSwipeState.id !== event.pointerId) return;
        var deltaX = event.clientX - detailSwipeState.startX;
        var deltaY = event.clientY - detailSwipeState.startY;
        var absX = Math.abs(deltaX);
        var absY = Math.abs(deltaY);
        detailSwipeState.deltaX = deltaX;
        detailSwipeState.deltaY = deltaY;

        if (!detailSwipeState.axis) {
          if (absY > 8 && absY > absX * 1.15) {
            detailSwipeState = null;
            return;
          }
          if (absX > 8 && absX > absY * 1.15) {
            detailSwipeState.axis = 'x';
            detailSwipeState.dragging = true;
            try { swipeSurface.setPointerCapture(event.pointerId); } catch (err) {}
          } else {
            return;
          }
        }

        if (detailSwipeState.axis !== 'x') return;
        detailSwipeState.dragging = true;
        if (event.cancelable) event.preventDefault();
        var limitedDelta = deltaX;
        if ((deltaX > 0 && currentDetailImageIndex <= 0) || (deltaX < 0 && currentDetailImageIndex >= currentDetailImages.length - 1)) {
          limitedDelta = deltaX * 0.28;
        }
        setDetailMediaDragOffset(limitedDelta, false);
      });

      function finishSwipe(event) {
        if (!detailSwipeState || (event && detailSwipeState.id !== event.pointerId)) return;
        var deltaX = detailSwipeState.deltaX || 0;
        var dragging = detailSwipeState.dragging;
        detailSwipeState = null;
        setDetailMediaDragOffset(0, true);
        if (!dragging || Math.abs(deltaX) < 54) return;
        if (deltaX < 0 && currentDetailImageIndex < currentDetailImages.length - 1) {
          showDetailImage(currentDetailImageIndex + 1);
        } else if (deltaX > 0 && currentDetailImageIndex > 0) {
          showDetailImage(currentDetailImageIndex - 1);
        }
      }

      swipeSurface.addEventListener('pointerup', finishSwipe);
      swipeSurface.addEventListener('pointercancel', finishSwipe);
      swipeSurface.addEventListener('lostpointercapture', finishSwipe);
    }

    modal.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeReviewsModal();
        return;
      }

      if (event.key !== 'Tab') return;

      var focusable = getFocusableElements(modal);
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    return modal;
  }

  function openReviewsModal() {
    refreshLanguage();
    var manifestUrl = getManifestUrl();
    if (!manifestUrl) {
      if (window.console && typeof window.console.warn === 'function') {
        window.console.warn('[Mexicada reviews] No review manifest URL found. Check that mexicada-global-reviews-manifest.json exists in theme assets.');
      }
      return;
    }

    if (!modalElement) {
      modalElement = createReviewsModal(manifestUrl, getBatchAssetUrls());
    }

    updateStaticReviewCopy(modalElement);
    syncModalReviewCount();

    lastFocusedElement = document.activeElement;

    if (modalCloseTimer) {
      window.clearTimeout(modalCloseTimer);
      modalCloseTimer = null;
    }
    if (modalAnimationFrame) {
      window.cancelAnimationFrame(modalAnimationFrame);
      modalAnimationFrame = null;
    }

    modalElement.classList.remove('is-closing', 'is-open');
    modalElement.hidden = false;
    document.documentElement.classList.add('mgr-modal-open');
    if (document.body) document.body.classList.add('mgr-modal-open');

    // Force a reflow so the start state is committed before is-open,
    // otherwise the transition is skipped and the modal pops in.
    void modalElement.offsetWidth;
    modalAnimationFrame = window.requestAnimationFrame(function () {
      modalAnimationFrame = null;
      modalElement.classList.add('is-open');
    });

    var panel = modalElement.querySelector('.mgr-modal__panel');
    if (panel && typeof panel.focus === 'function') {
      panel.focus({ preventScroll: true });
    }

    if (modalLoader && !modalLoader.state.started && !modalLoader.state.loading) {
      modalLoader.loadNextBatch();
    }
  }


  function closeReviewDetailModal() {
    if (!detailModalElement || detailModalElement.hidden) return;

    closeVerifyPopover(true);
    closeVerifySheet(true);
    pauseDetailVideo();

    var finishClose = function () {
      detailCloseTimer = null;
      detailModalElement.hidden = true;
      detailModalElement.classList.remove('is-closing', 'is-open');
      stopDetailVideo();
      unlockDetailPageScroll();

      if (lastDetailFocusedElement && typeof lastDetailFocusedElement.focus === 'function') {
        try {
          lastDetailFocusedElement.focus({ preventScroll: true });
        } catch (err) {
          // Avoid fallback focus without preventScroll because it can move the page.
        }
      }
    };

    if (detailAnimationFrame) {
      window.cancelAnimationFrame(detailAnimationFrame);
      detailAnimationFrame = null;
    }
    if (detailCloseTimer) {
      window.clearTimeout(detailCloseTimer);
      detailCloseTimer = null;
    }

    // Start the shrink-out animation.
    detailModalElement.classList.remove('is-open');
    detailModalElement.classList.add('is-closing');

    var prefersReducedMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
      finishClose();
      return;
    }

    // Hide after the CSS transition completes (keep in sync with the
    // 0.24s transition in mexicada-global-reviews.css).
    detailCloseTimer = window.setTimeout(finishClose, 240);
  }


  function closeVerifyPopover(immediate) {
    if (!detailModalElement) return;
    var popover = detailModalElement.querySelector('[data-mgr-verify-popover]');
    var button = detailModalElement.querySelector('[data-mgr-verify-tooltip-toggle]');
    if (!popover) return;

    if (verifyPopoverCloseTimer) {
      window.clearTimeout(verifyPopoverCloseTimer);
      verifyPopoverCloseTimer = null;
    }

    if (button) button.setAttribute('aria-expanded', 'false');

    if (immediate || popover.hidden) {
      popover.classList.remove('is-visible');
      popover.classList.remove('is-closing');
      popover.hidden = true;
      return;
    }

    popover.classList.remove('is-visible');
    popover.classList.add('is-closing');
    verifyPopoverCloseTimer = window.setTimeout(function () {
      popover.hidden = true;
      popover.classList.remove('is-closing');
      verifyPopoverCloseTimer = null;
    }, 190);
  }

  function toggleVerifyPopover() {
    if (!detailModalElement) return;
    var popover = detailModalElement.querySelector('[data-mgr-verify-popover]');
    var button = detailModalElement.querySelector('[data-mgr-verify-tooltip-toggle]');
    if (!popover || !button) return;

    var willOpen = popover.hidden || !popover.classList.contains('is-visible');
    if (!willOpen) {
      closeVerifyPopover(false);
      return;
    }

    if (verifyPopoverCloseTimer) {
      window.clearTimeout(verifyPopoverCloseTimer);
      verifyPopoverCloseTimer = null;
    }

    popover.hidden = false;
    popover.classList.remove('is-closing');
    window.requestAnimationFrame(function () {
      popover.classList.add('is-visible');
    });
    button.setAttribute('aria-expanded', 'true');
  }

  function openVerifySheet() {
    if (!detailModalElement) return;
    closeVerifyPopover(true);
    var sheet = detailModalElement.querySelector('[data-mgr-verify-sheet]');
    if (!sheet) return;

    if (verifySheetCloseTimer) {
      window.clearTimeout(verifySheetCloseTimer);
      verifySheetCloseTimer = null;
    }

    sheet.hidden = false;
    sheet.classList.remove('is-closing');
    window.requestAnimationFrame(function () {
      sheet.classList.add('is-visible');
    });
  }

  function closeVerifySheet(immediate) {
    if (!detailModalElement) return;
    var sheet = detailModalElement.querySelector('[data-mgr-verify-sheet]');
    if (!sheet) return;

    if (verifySheetCloseTimer) {
      window.clearTimeout(verifySheetCloseTimer);
      verifySheetCloseTimer = null;
    }

    if (immediate || sheet.hidden) {
      sheet.classList.remove('is-visible');
      sheet.classList.remove('is-closing');
      sheet.hidden = true;
      return;
    }

    sheet.classList.remove('is-visible');
    sheet.classList.add('is-closing');
    verifySheetCloseTimer = window.setTimeout(function () {
      sheet.hidden = true;
      sheet.classList.remove('is-closing');
      verifySheetCloseTimer = null;
    }, 270);
  }

  function bindReviewDetailSwipe(modal) {
    var swipeSurface = modal ? modal.querySelector('[data-mgr-detail-image-wrap]') : null;
    if (!swipeSurface || swipeSurface.getAttribute('data-mgr-swipe-bound') === 'true') return;
    swipeSurface.setAttribute('data-mgr-swipe-bound', 'true');

    var touchSwipeState = null;
    var hasTouchEvents = ('ontouchstart' in window) || (navigator && navigator.maxTouchPoints > 0);

    swipeSurface.addEventListener('pointerdown', function (event) {
      if (!isSmallDetailViewport() || currentDetailImages.length < 2) return;
      // On touch devices, use the touch event path below. It lets vertical drags
      // keep scrolling normally while horizontal drags still move the attached
      // photo track. Letting both pointer and touch handlers run can cancel each
      // other on iOS/Android and make the photo area feel frozen.
      if (hasTouchEvents && event.pointerType === 'touch') return;
      if (event.button && event.button !== 0) return;
      if (event.target.closest('button, a, input, select, textarea, [data-mgr-detail-thumbs], [data-mgr-detail-close], [data-mgr-video-controls]')) return;
      detailSwipeState = {
        id: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        deltaX: 0,
        deltaY: 0,
        dragging: false,
        axis: null
      };
      // Do not capture the pointer yet. Capturing immediately makes vertical
      // page/modal scrolling feel dead when a customer starts a swipe on top of
      // a review image/video. We only capture after the gesture is clearly horizontal.
    });

    swipeSurface.addEventListener('pointermove', function (event) {
      if (!detailSwipeState || detailSwipeState.id !== event.pointerId) return;
      var deltaX = event.clientX - detailSwipeState.startX;
      var deltaY = event.clientY - detailSwipeState.startY;
      var absX = Math.abs(deltaX);
      var absY = Math.abs(deltaY);
      detailSwipeState.deltaX = deltaX;
      detailSwipeState.deltaY = deltaY;

      if (!detailSwipeState.axis) {
        if (absY > 8 && absY > absX * 1.15) {
          // Vertical gesture: abandon the media swipe so the modal/page can scroll.
          detailSwipeState = null;
          return;
        }
        if (absX > 8 && absX > absY * 1.15) {
          detailSwipeState.axis = 'x';
          detailSwipeState.dragging = true;
          try { swipeSurface.setPointerCapture(event.pointerId); } catch (err) {}
        } else {
          return;
        }
      }

      if (detailSwipeState.axis !== 'x') return;
      detailSwipeState.dragging = true;
      if (event.cancelable) event.preventDefault();
      var limitedDelta = deltaX;
      if ((deltaX > 0 && currentDetailImageIndex <= 0) || (deltaX < 0 && currentDetailImageIndex >= currentDetailImages.length - 1)) {
        limitedDelta = deltaX * 0.28;
      }
      setDetailMediaDragOffset(limitedDelta, false);
    });

    function finishSwipe(event) {
      if (!detailSwipeState || (event && detailSwipeState.id !== event.pointerId)) return;
      var deltaX = detailSwipeState.deltaX || 0;
      var dragging = detailSwipeState.dragging;
      detailSwipeState = null;

      if (dragging) detailSuppressClickUntil = Date.now() + 320;

      if (!dragging || Math.abs(deltaX) < 54) {
        setDetailMediaDragOffset(0, true);
        return;
      }

      if (deltaX < 0 && currentDetailImageIndex < currentDetailImages.length - 1) {
        showDetailImage(currentDetailImageIndex + 1);
      } else if (deltaX > 0 && currentDetailImageIndex > 0) {
        showDetailImage(currentDetailImageIndex - 1);
      } else {
        setDetailMediaDragOffset(0, true);
      }
    }

    swipeSurface.addEventListener('pointerup', finishSwipe);
    swipeSurface.addEventListener('pointercancel', finishSwipe);
    swipeSurface.addEventListener('lostpointercapture', finishSwipe);

    swipeSurface.addEventListener('touchstart', function (event) {
      if (!isSmallDetailViewport() || currentDetailImages.length < 2) return;
      if (!event.touches || event.touches.length !== 1) return;
      if (event.target.closest('button, a, input, select, textarea, [data-mgr-detail-thumbs], [data-mgr-detail-close], [data-mgr-video-controls]')) return;
      var touch = event.touches[0];
      touchSwipeState = {
        startX: touch.clientX,
        startY: touch.clientY,
        deltaX: 0,
        deltaY: 0,
        dragging: false,
        axis: null
      };
    }, { passive: true });

    swipeSurface.addEventListener('touchmove', function (event) {
      if (!touchSwipeState || !event.touches || event.touches.length !== 1) return;
      var touch = event.touches[0];
      var deltaX = touch.clientX - touchSwipeState.startX;
      var deltaY = touch.clientY - touchSwipeState.startY;
      var absX = Math.abs(deltaX);
      var absY = Math.abs(deltaY);
      touchSwipeState.deltaX = deltaX;
      touchSwipeState.deltaY = deltaY;

      if (!touchSwipeState.axis) {
        if (absY > 8 && absY > absX * 1.15) {
          // Vertical gesture: release immediately so the detail modal can scroll.
          touchSwipeState = null;
          setDetailMediaDragOffset(0, true);
          return;
        }
        if (absX > 8 && absX > absY * 1.15) {
          touchSwipeState.axis = 'x';
          touchSwipeState.dragging = true;
        } else {
          return;
        }
      }

      if (touchSwipeState.axis !== 'x') return;
      touchSwipeState.dragging = true;
      if (event.cancelable) event.preventDefault();
      var limitedDelta = deltaX;
      if ((deltaX > 0 && currentDetailImageIndex <= 0) || (deltaX < 0 && currentDetailImageIndex >= currentDetailImages.length - 1)) {
        limitedDelta = deltaX * 0.28;
      }
      setDetailMediaDragOffset(limitedDelta, false);
    }, { passive: false });

    function finishTouchSwipe() {
      if (!touchSwipeState) return;
      var deltaX = touchSwipeState.deltaX || 0;
      var dragging = touchSwipeState.dragging;
      touchSwipeState = null;

      if (dragging) detailSuppressClickUntil = Date.now() + 320;

      if (!dragging || Math.abs(deltaX) < 54) {
        setDetailMediaDragOffset(0, true);
        return;
      }

      if (deltaX < 0 && currentDetailImageIndex < currentDetailImages.length - 1) {
        showDetailImage(currentDetailImageIndex + 1);
      } else if (deltaX > 0 && currentDetailImageIndex > 0) {
        showDetailImage(currentDetailImageIndex - 1);
      } else {
        setDetailMediaDragOffset(0, true);
      }
    }

    swipeSurface.addEventListener('touchend', finishTouchSwipe, { passive: true });
    swipeSurface.addEventListener('touchcancel', finishTouchSwipe, { passive: true });
  }

  function createReviewDetailModal() {
    var modal = document.createElement('div');
    modal.id = 'mexicada-global-review-detail-modal';
    modal.className = 'mgr-review-detail-modal';
    modal.hidden = true;

    var ntClass = isTranslatedLocale() ? ' notranslate gtranslate-no-translate gt-skip' : '';
    var ntAttr = translatedAttr();

    modal.innerHTML = [
      '<div class="mgr-review-detail__overlay" data-mgr-detail-close></div>',
      '<div class="mgr-review-detail__panel" role="dialog" aria-modal="true" aria-labelledby="mgr-review-detail-name" tabindex="-1">',
        '<button type="button" class="mgr-review-detail__close" data-mgr-detail-close aria-label="' + escapeHtml(t('closeReview')) + '">×</button>',
        '<div class="mgr-review-detail__image-wrap" data-mgr-detail-image-wrap>',
          '<button data-testid="image-slider-prev" type="button" class="post-image-slider-button-prev mgr-review-detail__slider-button mgr-review-detail__slider-button--prev" data-mgr-detail-prev tabindex="0" aria-label="Previous slide" aria-controls="mgr-review-detail-image" aria-disabled="false" hidden><svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m7.828 11 5.364-5.364-1.414-1.414L4 12l7.778 7.778 1.414-1.414L7.828 13H20v-2H7.828Z"></path></svg></button>',
          '<div class="mgr-review-detail__track" data-mgr-detail-track></div>',
          '<img id="mgr-review-detail-image" class="mgr-review-detail__image" data-mgr-detail-image alt="Customer review photo" hidden aria-hidden="true">',
          '<div class="mgr-review-detail__video-host" data-mgr-detail-video-host hidden aria-hidden="true"></div>',
          '<button data-testid="image-slider-next" type="button" class="post-image-slider-button-next mgr-review-detail__slider-button mgr-review-detail__slider-button--next" data-mgr-detail-next tabindex="0" aria-label="Next slide" aria-controls="mgr-review-detail-image" aria-disabled="false" hidden><svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m16.172 11-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2h12.172Z"></path></svg></button>',
          '<div class="mgr-review-detail__thumbs" data-mgr-detail-thumbs hidden></div>',
        '</div>',
        '<div class="mgr-review-detail__content">',
          '<div class="mgr-review-detail__topline">',
            '<div>',
              '<h3 id="mgr-review-detail-name" class="mgr-review-detail__name"></h3>',
              '<div class="mgr-review-detail__stars" aria-label="5 out of 5 stars"></div>',
            '</div>',
            '<div class="mgr-review-detail__verified-wrap" hidden>',
              '<div class="mgr-review-detail__verified"><span class="mgr-card__verified" aria-hidden="true"></span><span class="mgr-review-detail__verified-text' + ntClass + '"' + ntAttr + '>' + escapeHtml(t('verifiedLabel')) + '</span></div>',
              '<button type="button" class="mgr-review-detail__info-button" data-mgr-verify-tooltip-toggle aria-label="' + escapeHtml(t('moreVerifiedInfo')) + '" aria-expanded="false">',
                '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M7.99992 14.6666C4.31792 14.6666 1.33325 11.682 1.33325 7.99998C1.33325 4.31798 4.31792 1.33331 7.99992 1.33331C11.6819 1.33331 14.6666 4.31798 14.6666 7.99998C14.6666 11.682 11.6819 14.6666 7.99992 14.6666ZM7.99992 13.3333C9.41441 13.3333 10.771 12.7714 11.7712 11.7712C12.7713 10.771 13.3333 9.41447 13.3333 7.99998C13.3333 6.58549 12.7713 5.22894 11.7712 4.22874C10.771 3.22855 9.41441 2.66665 7.99992 2.66665C6.58543 2.66665 5.22888 3.22855 4.22868 4.22874C3.22849 5.22894 2.66659 6.58549 2.66659 7.99998C2.66659 9.41447 3.22849 10.771 4.22868 11.7712C5.22888 12.7714 6.58543 13.3333 7.99992 13.3333ZM7.33325 4.66665H8.66659V5.99998H7.33325V4.66665ZM7.33325 7.33331H8.66659V11.3333H7.33325V7.33331Z" fill="black" fill-opacity="1"></path></svg>',
              '</button>',
              '<div class="mgr-review-detail__verify-popover" data-mgr-verify-popover hidden>',
                '<p class="mgr-review-detail__verify-copy' + ntClass + '"' + ntAttr + '>' + escapeHtml(t('verifiedInfo')) + '</p>',
                '<button type="button" class="mgr-review-detail__verify-learn' + ntClass + '" data-mgr-verify-learn-more' + ntAttr + '>' + escapeHtml(t('learnMore')) + '</button>',
              '</div>',
            '</div>',
          '</div>',
          '<div class="mgr-review-detail__date" hidden></div>',
          '<p class="mgr-review-detail__text"></p>',
          '<div class="mgr-review-detail__extra" hidden></div>',
          '<div class="mgr-review-detail__product" hidden>',
            '<img class="mgr-review-detail__product-image" data-mgr-detail-product-image alt="Reviewed product">',
            '<div class="mgr-review-detail__product-copy">',
              '<div class="mgr-review-detail__product-name"></div>',
              '<a class="mgr-review-detail__product-link' + ntClass + '" href="#"' + ntAttr + '><span class="mgr-review-detail__product-link-icon" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false"><path d="M4.66668 5.33336V4.00002C4.66668 3.11598 5.01786 2.26812 5.64298 1.64301C6.26810 1.01789 7.11595 0.66669 8.00000 0.66669C8.88406 0.66669 9.73191 1.01789 10.35702 1.64301C10.98214 2.26812 11.33334 3.11598 11.33334 4.00002V5.33336H13.33334C13.51014 5.33336 13.67971 5.40360 13.80474 5.52863C13.92977 5.65365 14.00001 5.82322 14.00001 6.00002V14.00000C14.00001 14.17681 13.92977 14.34638 13.80474 14.47141C13.67971 14.59643 13.51014 14.66668 13.33334 14.66668H2.66667C2.48987 14.66668 2.32030 14.59643 2.19527 14.47141C2.07025 14.34638 2.00001 14.17681 2.00001 14.00000V6.00002C2.00001 5.82322 2.07025 5.65365 2.19527 5.52863C2.32030 5.40360 2.48987 5.33336 2.66667 5.33336H4.66668ZM4.66668 6.66669H3.33334V13.33336H12.66668V6.66669H11.33334V8.00002H10.00000V6.66669H6.00000V8.00002H4.66668V6.66669ZM6.00000 5.33336H10.00000V4.00002C10.00000 3.46959 9.78930 2.96088 9.41422 2.58581C9.03915 2.21074 8.53044 2.00002 8.00000 2.00002C7.46958 2.00002 6.96087 2.21074 6.58579 2.58581C6.21072 2.96088 6.00000 3.46959 6.00000 4.00002V5.33336Z" fill="currentColor"></path></svg></span><span class="mgr-review-detail__product-link-text">' + escapeHtml(t('viewProduct')) + '</span></a>',
            '</div>',
          '</div>',
        '</div>',
      '</div>',

      '<div class="mgr-review-process-sheet" data-mgr-verify-sheet hidden>',
        '<div class="mgr-review-process-sheet__overlay" data-mgr-verify-sheet-close></div>',
        '<div class="mgr-review-process-sheet__panel" role="dialog" aria-modal="true" aria-label="' + escapeHtml(t('howWeVerifyTitle')) + '">',
          '<button type="button" class="mgr-review-process-sheet__close" data-mgr-verify-sheet-close aria-label="' + escapeHtml(t('closeVerificationInfo')) + '">',
            '<svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">',
              '<path d="m12 15-4.243-4.243 1.415-1.414L12 12.172l2.828-2.829 1.415 1.414L12 15Z" fill="#161718"></path>',
            '</svg>',
          '</button>',
          '<h2 class="' + ntClass.trim() + '"' + ntAttr + '>' + escapeHtml(t('howWeVerifyTitle')) + '</h2>',
          '<p class="' + ntClass.trim() + '"' + ntAttr + '>' + escapeHtml(t('sheetParagraph1')) + '</p>',
          '<p class="' + ntClass.trim() + '"' + ntAttr + '>' + escapeHtml(t('sheetParagraph2')) + '</p>',
          '<p class="' + ntClass.trim() + '"' + ntAttr + '>' + escapeHtml(t('sheetParagraph3')) + '</p>',
          '<p class="' + ntClass.trim() + '"' + ntAttr + '>' + escapeHtml(t('sheetParagraph4')) + '</p>',
          '<p class="' + ntClass.trim() + '"' + ntAttr + '>' + escapeHtml(t('sheetParagraph5')) + '</p>',
        '</div>',
      '</div>'
    ].join('');

    bindReviewDetailSwipe(modal);

    modal.addEventListener('click', function (event) {
      if (Date.now() < detailSuppressClickUntil) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      if (!event.target.closest('[data-mgr-video-settings-wrap]')) {
        closeOtherDetailVideoMenus();
      }

      var nativeVideo = event.target.closest('[data-mgr-detail-video-host] video');
      if (nativeVideo) {
        // Native MP4/WebM video click handling lives on the player itself.
        // Mobile taps only show/hide controls; desktop taps play/pause.
        return;
      }

      // Let Cloudflare Stream handle its own click/tap controls. Capturing
      // clicks on the <stream> element here made its settings menus close as
      // soon as the mouse/touch was released. Native MP4/WebM videos still
      // get the tap-to-play/pause behavior above.

      var prevButton = event.target.closest('[data-mgr-detail-prev]');
      if (prevButton) {
        event.preventDefault();
        event.stopPropagation();
        if (!prevButton.disabled && prevButton.getAttribute('aria-disabled') !== 'true') {
          showDetailImage(currentDetailImageIndex - 1);
        }
        return;
      }

      var nextButton = event.target.closest('[data-mgr-detail-next]');
      if (nextButton) {
        event.preventDefault();
        event.stopPropagation();
        if (!nextButton.disabled && nextButton.getAttribute('aria-disabled') !== 'true') {
          showDetailImage(currentDetailImageIndex + 1);
        }
        return;
      }

      var thumbButton = event.target.closest('[data-mgr-detail-thumb]');
      if (thumbButton) {
        event.preventDefault();
        event.stopPropagation();
        showDetailImage(parseInt(thumbButton.getAttribute('data-mgr-detail-thumb'), 10) || 0);
        return;
      }

      if (event.target.closest('[data-mgr-verify-tooltip-toggle]')) {
        event.preventDefault();
        event.stopPropagation();
        toggleVerifyPopover();
        return;
      }

      if (event.target.closest('[data-mgr-verify-learn-more]')) {
        event.preventDefault();
        event.stopPropagation();
        openVerifySheet();
        return;
      }

      if (event.target.closest('[data-mgr-verify-sheet-close]')) {
        event.preventDefault();
        event.stopPropagation();
        closeVerifySheet();
        return;
      }

      if (!event.target.closest('[data-mgr-verify-popover]')) {
        closeVerifyPopover();
      }

      if (event.target.closest('[data-mgr-detail-close]')) {
        closeReviewDetailModal();
      }
    });

    modal.addEventListener('keydown', function (event) {
      if ((event.key === 'ArrowLeft' || event.key === 'Left') && currentDetailImages.length > 1) {
        event.preventDefault();
        showDetailImage(currentDetailImageIndex - 1);
        return;
      }

      if ((event.key === 'ArrowRight' || event.key === 'Right') && currentDetailImages.length > 1) {
        event.preventDefault();
        showDetailImage(currentDetailImageIndex + 1);
        return;
      }

      if (event.key === 'Escape') {
        var sheet = modal.querySelector('[data-mgr-verify-sheet]');
        var popover = modal.querySelector('[data-mgr-verify-popover]');
        if (sheet && !sheet.hidden) {
          closeVerifySheet();
          return;
        }
        if (popover && !popover.hidden) {
          closeVerifyPopover();
          return;
        }
        closeReviewDetailModal();
        return;
      }

      if (event.key !== 'Tab') return;

      var focusable = getFocusableElements(modal);
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    document.body.appendChild(modal);
    return modal;
  }

  function renderDetailSliderThumbs() {
    if (!detailModalElement) return;
    var thumbs = detailModalElement.querySelector('[data-mgr-detail-thumbs]');
    if (!thumbs) return;

    thumbs.innerHTML = '';
    thumbs.hidden = currentDetailImages.length < 2;
    if (currentDetailImages.length < 2) return;

    currentDetailImages.forEach(function (item, index) {
      var thumbButton = document.createElement('button');
      thumbButton.type = 'button';
      thumbButton.className = 'mgr-review-detail__thumb';
      thumbButton.setAttribute('data-mgr-detail-thumb', String(index));
      thumbButton.setAttribute('aria-label', 'Show photo ' + String(index + 1));

      thumbButton.classList.toggle('mgr-review-detail__thumb--video', item.type === 'video');

      var thumbImage = document.createElement('img');
      thumbImage.src = getMediaThumbUrl(item);
      thumbImage.alt = item.alt || t('customerReviewPhoto');
      thumbImage.loading = 'lazy';
      thumbImage.decoding = 'async';
      thumbButton.appendChild(thumbImage);
      if (item.type === 'video') {
        thumbButton.appendChild(createVideoPlayIcon('mgr-video-play-badge mgr-review-detail__thumb-play'));
      }
      thumbs.appendChild(thumbButton);
    });
  }

  function updateDetailSliderControls() {
    if (!detailModalElement) return;
    var hasMultiple = currentDetailImages.length > 1;
    var prev = detailModalElement.querySelector('[data-mgr-detail-prev]');
    var next = detailModalElement.querySelector('[data-mgr-detail-next]');

    if (prev) {
      var prevDisabled = !hasMultiple || currentDetailImageIndex <= 0;
      prev.hidden = !hasMultiple;
      prev.disabled = prevDisabled;
      prev.setAttribute('aria-disabled', prevDisabled ? 'true' : 'false');
      prev.setAttribute('tabindex', prevDisabled ? '-1' : '0');
    }

    if (next) {
      var nextDisabled = !hasMultiple || currentDetailImageIndex >= currentDetailImages.length - 1;
      next.hidden = !hasMultiple;
      next.disabled = nextDisabled;
      next.setAttribute('aria-disabled', nextDisabled ? 'true' : 'false');
      next.setAttribute('tabindex', nextDisabled ? '-1' : '0');
    }

    var thumbs = detailModalElement.querySelectorAll('[data-mgr-detail-thumb]');
    Array.prototype.forEach.call(thumbs, function (thumb, index) {
      var isActive = index === currentDetailImageIndex;
      thumb.classList.toggle('is-active', isActive);
      thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function formatDetailVideoTime(value) {
    var seconds = Number(value);
    if (!isFinite(seconds) || seconds < 0) seconds = 0;
    seconds = Math.floor(seconds);
    var mins = Math.floor(seconds / 60);
    var secs = seconds % 60;
    return String(mins) + ':' + (secs < 10 ? '0' : '') + String(secs);
  }

  function getDetailVideoSvg(name) {
    if (name === 'pause') {
      return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="currentColor" aria-hidden="true" focusable="false"><path d="M15 12h6a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2V14a2 2 0 0 1 2-2Zm12 0h6a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2V14a2 2 0 0 1 2-2Z"></path></svg>';
    }
    if (name === 'volume') {
      return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" fill="currentColor" aria-hidden="true" focusable="false"><path d="M533.6 32.5C598.5 85.3 640 165.8 640 256s-41.5 170.8-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8c54.2-44 88.7-111 88.7-186.2s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5c21.5 17.6 35.4 44.4 35.4 74.5s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64v384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z"></path></svg>';
    }
    if (name === 'muted') {
      return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="currentColor" aria-hidden="true" focusable="false"><path d="M301.1 34.8C312.6 40 320 51.4 320 64v384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM425 167l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"></path></svg>';
    }
    if (name === 'settings') {
      return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" aria-hidden="true" focusable="false"><path d="M495.9 166.6c3.2 8.7.5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4l-55.6 17.8c-8.8 2.8-18.6.3-24.5-6.8-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4c-1.1-8.4-1.7-16.9-1.7-25.5s.6-17.1 1.7-25.4l-43.3-39.4c-6.9-6.2-9.6-15.9-6.4-24.6 4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2 5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8 8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"></path></svg>';
    }
    if (name === 'fullscreen') {
      return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="currentColor" aria-hidden="true" focusable="false"><path d="M28 10h9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-6h-6a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm9 28h-9a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h6v-6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1zM11 10h9a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-6v6a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1zm3 24h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v6z"></path></svg>';
    }
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="currentColor" aria-hidden="true" focusable="false"><path d="M14 15.06V33a2 2 0 0 0 2.93 1.77l17.09-8.97a2 2 0 0 0 0-3.54L16.93 13.3A2 2 0 0 0 14 15.06z"></path></svg>';
  }

  function setDetailVideoButton(button, iconName, label) {
    if (!button) return;
    button.innerHTML = getDetailVideoSvg(iconName) + '<span class="mgr-visually-hidden">' + escapeHtml(label || '') + '</span>';
  }

  function setNativeVideoMuted(video, muted) {
    if (!video) return;
    try {
      video.muted = !!muted;
      video.defaultMuted = !!muted;
      if (muted) {
        video.setAttribute('muted', '');
      } else {
        video.removeAttribute('muted');
        if (!video.volume || video.volume <= 0) video.volume = 1;
      }
    } catch (err) {}
  }

  function forceNativeVideoUnmuted(video, volumeValue) {
    if (!video) return;
    var nextVolume = parseFloat(volumeValue || '1');
    if (!isFinite(nextVolume) || nextVolume <= 0) nextVolume = 1;
    nextVolume = Math.max(0.01, Math.min(1, nextVolume));

    function apply() {
      try {
        video.volume = nextVolume;
        video.muted = false;
        video.defaultMuted = false;
        video.removeAttribute('muted');
      } catch (err) {}
    }

    apply();
    if (window.requestAnimationFrame) window.requestAnimationFrame(apply);
    window.setTimeout(apply, 40);
    window.setTimeout(apply, 140);
  }

  function forceNativeVideoMuted(video) {
    if (!video) return;
    try {
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
    } catch (err) {}
  }

  function formatDetailVideoSpeed(rate) {
    var value = Number(rate);
    if (!isFinite(value) || value <= 0) value = 1;
    if (Math.abs(value - Math.round(value)) < 0.001) return String(Math.round(value)) + 'x';
    return String(value).replace(/0+$/, '').replace(/\.$/, '') + 'x';
  }

  function getVideoSettingsCheckSvg() {
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor" aria-hidden="true" focusable="false"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7l233.4-233.3c12.5-12.5 32.8-12.5 45.3 0z"></path></svg>';
  }


  var DETAIL_VIDEO_QUALITY_LADDER = [2160, 1440, 1080, 720, 480, 360, 240];

  function normalizeVideoQualityValue(value) {
    if (value === null || value === undefined) return '';
    if (String(value).toLowerCase && String(value).toLowerCase() === 'auto') return 'auto';
    var match = String(value).match(/(2160|1440|1080|720|480|360|240|144)(?:p)?/i);
    if (match) return String(parseInt(match[1], 10));
    var number = parseInt(value, 10);
    if (isFinite(number) && number > 0) return String(number);
    return '';
  }

  function normalizeVideoQualityList(raw) {
    var values = [];
    var seen = {};

    function add(value) {
      var normalized = normalizeVideoQualityValue(value);
      if (!normalized || normalized === 'auto' || seen[normalized]) return;
      seen[normalized] = true;
      values.push(normalized);
    }

    if (Array.isArray(raw)) {
      raw.forEach(function (value) {
        if (value && typeof value === 'object') {
          add(value.quality || value.label || value.height || value.resolution || value.name);
        } else {
          add(value);
        }
      });
    } else if (raw && typeof raw === 'object') {
      Object.keys(raw).forEach(function (key) { add(key); });
    } else if (raw) {
      String(raw).split(',').forEach(function (value) { add(value); });
    }

    values.sort(function (a, b) { return parseInt(b, 10) - parseInt(a, 10); });
    return values;
  }

  function getVideoSourceQuality(item, fallbackUrl) {
    if (!item || typeof item !== 'object') {
      return normalizeVideoQualityValue(fallbackUrl || '');
    }
    return normalizeVideoQualityValue(
      item.quality ||
      item.label ||
      item.height ||
      item.resolution ||
      item.name ||
      item.size ||
      item.src ||
      item.url ||
      fallbackUrl ||
      ''
    );
  }

  function normalizeVideoSourceList(raw, baseUrl) {
    var sources = [];
    var seen = {};

    function add(url, quality) {
      if (!url) return;
      url = resolveAssetUrl(String(url), baseUrl);
      if (!url || seen[url]) return;
      seen[url] = true;
      sources.push({
        url: url,
        quality: normalizeVideoQualityValue(quality || url)
      });
    }

    if (Array.isArray(raw)) {
      raw.forEach(function (item) {
        if (typeof item === 'string') {
          add(item, item);
        } else if (item && typeof item === 'object') {
          var url = item.src || item.url || item.video || item.video_url || item.videoUrl || item.file || item.path || '';
          add(url, getVideoSourceQuality(item, url));
        }
      });
    } else if (raw && typeof raw === 'object') {
      Object.keys(raw).forEach(function (quality) {
        add(raw[quality], quality);
      });
    }

    sources.sort(function (a, b) {
      var aq = parseInt(a.quality || '0', 10) || 0;
      var bq = parseInt(b.quality || '0', 10) || 0;
      return bq - aq;
    });

    return sources;
  }

  function getNativeVideoMaxQuality(video) {
    if (!video) return 0;
    var width = parseInt(video.videoWidth, 10) || 0;
    var height = parseInt(video.videoHeight, 10) || 0;
    if (width && height) return Math.min(width, height);
    return Math.max(width, height);
  }

  function getDerivedNativeVideoQualities(video) {
    var maxQuality = getNativeVideoMaxQuality(video);
    if (!maxQuality) return [];
    return DETAIL_VIDEO_QUALITY_LADDER.filter(function (quality) {
      return quality <= maxQuality + 12;
    }).map(function (quality) { return String(quality); });
  }

  function getPlayerAvailableVideoQualities(player) {
    if (!player) return [];
    var declared = player._mgrVideoDeclaredQualities || [];
    var sources = player._mgrVideoSources || [];
    var values = [];
    var seen = {};

    function add(value) {
      var normalized = normalizeVideoQualityValue(value);
      if (!normalized || normalized === 'auto' || seen[normalized]) return;
      seen[normalized] = true;
      values.push(normalized);
    }

    sources.forEach(function (source) { add(source && source.quality); });
    declared.forEach(function (quality) { add(quality); });

    if (!values.length) {
      getDerivedNativeVideoQualities(player.querySelector('[data-mgr-native-video]')).forEach(add);
    }

    values.sort(function (a, b) { return parseInt(b, 10) - parseInt(a, 10); });
    return values;
  }

  function findVideoSourceByQuality(player, quality) {
    if (!player || !quality || quality === 'auto') return null;
    var sources = player._mgrVideoSources || [];
    for (var i = 0; i < sources.length; i += 1) {
      if (String(sources[i].quality) === String(quality)) return sources[i];
    }
    return null;
  }

  function setNativeVideoSourceForQuality(player, video, quality) {
    if (!player || !video) return;
    var source = null;
    if (quality === 'auto') {
      var autoUrl = player._mgrVideoAutoUrl || '';
      if (autoUrl) source = { url: autoUrl, quality: 'auto' };
    } else {
      source = findVideoSourceByQuality(player, quality);
    }

    if (!source || !source.url) return;

    var currentSrc = video.currentSrc || video.src || '';
    if (currentSrc === source.url || currentSrc.replace(/^https?:/, '') === source.url.replace(/^https?:/, '')) return;

    var currentTime = isFinite(video.currentTime) ? video.currentTime : 0;
    var wasPaused = video.paused;
    var wasMuted = video.muted;
    var volume = video.volume;
    var playbackRate = video.playbackRate || 1;

    function restoreAfterSwap() {
      video.removeEventListener('loadedmetadata', restoreAfterSwap);
      try {
        if (currentTime && isFinite(video.duration)) video.currentTime = Math.min(currentTime, Math.max(0, video.duration - 0.15));
        video.playbackRate = playbackRate;
        video.volume = volume;
        setNativeVideoMuted(video, wasMuted);
        if (!wasPaused) {
          var promise = video.play && video.play();
          if (promise && typeof promise.catch === 'function') promise.catch(function () {});
        }
      } catch (err) {}
      syncCustomVideoControls(player);
      applyDetailDynamicMediaSizing();
    }

    video.addEventListener('loadedmetadata', restoreAfterSwap);
    video.src = source.url;
    try { video.load(); } catch (err) {}
  }

  function renderNativeVideoQualityMenu(player) {
    if (!player) return;
    var menu = player.querySelector('[data-mgr-video-select-menu="quality"]');
    if (!menu) return;

    var qualities = getPlayerAvailableVideoQualities(player);
    var active = player.getAttribute('data-mgr-video-quality') || 'auto';
    var activeIsAvailable = active === 'auto' || qualities.indexOf(active) !== -1;
    if (!activeIsAvailable) {
      active = 'auto';
      player.setAttribute('data-mgr-video-quality', active);
    }

    var checkSvg = getVideoSettingsCheckSvg();
    var html = qualities.map(function (quality) {
      var isActive = quality === active;
      return '<button type="button" class="mgr-video-option' + (isActive ? ' is-active' : '') + '" data-mgr-video-quality="' + quality + '" role="option" aria-selected="' + (isActive ? 'true' : 'false') + '"><span class="mgr-video-option-check" aria-hidden="true">' + checkSvg + '</span><span class="notranslate gtranslate-no-translate gt-skip" translate="no">' + quality + '</span></button>';
    }).join('');

    html += '<button type="button" class="mgr-video-option' + (active === 'auto' ? ' is-active' : '') + '" data-mgr-video-quality="auto" role="option" aria-selected="' + (active === 'auto' ? 'true' : 'false') + '"><span class="mgr-video-option-check" aria-hidden="true">' + checkSvg + '</span><span class="notranslate gtranslate-no-translate gt-skip" translate="no">auto</span></button>';
    menu.innerHTML = html;
  }

  function hideVideoSettingsMenu(menu) {
    if (!menu) return;
    menu.hidden = true;
    var player = menu.closest('[data-mgr-native-player]');
    if (player) {
      player.classList.remove('is-settings-open');
      var settingsButton = player.querySelector('[data-mgr-video-settings]');
      if (settingsButton) settingsButton.setAttribute('aria-expanded', 'false');
      Array.prototype.forEach.call(player.querySelectorAll('[data-mgr-video-select-menu]'), function (selectMenu) {
        selectMenu.hidden = true;
      });
      Array.prototype.forEach.call(player.querySelectorAll('[data-mgr-video-setting-select]'), function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
    }
  }

  function syncCustomVideoControls(player) {
    if (!player) return;
    var video = player.querySelector('[data-mgr-native-video]');
    if (!video) return;
    var playButton = player.querySelector('[data-mgr-video-play]');
    var muteButton = player.querySelector('[data-mgr-video-mute]');
    var volume = player.querySelector('[data-mgr-video-volume]');
    var seek = player.querySelector('[data-mgr-video-seek]');
    var time = player.querySelector('[data-mgr-video-time]');
    var duration = isFinite(video.duration) && video.duration > 0 ? video.duration : 0;
    var current = isFinite(video.currentTime) ? video.currentTime : 0;
    var progress = duration ? Math.max(0, Math.min(1, current / duration)) : 0;

    setDetailVideoButton(playButton, video.paused ? 'play' : 'pause', video.paused ? 'Play' : 'Pause');

    if (video.muted || video.volume <= 0) {
      setDetailVideoButton(muteButton, 'muted', 'Currently muted. Click to unmute.');
    } else {
      setDetailVideoButton(muteButton, 'volume', 'Currently unmuted. Volume set to ' + String(Math.round(video.volume * 100)) + ' percent. Click to mute.');
    }

    if (volume) {
      volume.value = video.muted ? '0' : String(video.volume || 0);
      volume.style.setProperty('--mgr-video-volume', String(video.muted ? 0 : video.volume || 0));
    }

    if (seek) {
      seek.value = String(Math.round(progress * 1000));
      seek.style.setProperty('--mgr-video-progress', String(progress));
      seek.setAttribute('aria-valuenow', String(Math.round(current)));
      seek.setAttribute('aria-valuetext', formatDetailVideoTime(current) + ' of ' + formatDetailVideoTime(duration));
    }

    if (time) {
      time.textContent = formatDetailVideoTime(current) + ' / ' + formatDetailVideoTime(duration);
    }

    var speedValue = player.querySelector('[data-mgr-video-speed-value]');
    if (speedValue) speedValue.textContent = formatDetailVideoSpeed(video.playbackRate || 1);

    var qualityValue = player.querySelector('[data-mgr-video-quality-value]');
    if (qualityValue) qualityValue.textContent = player.getAttribute('data-mgr-video-quality') || 'auto';
  }

  function closeOtherDetailVideoMenus(player) {
    if (!detailModalElement) return;
    Array.prototype.forEach.call(detailModalElement.querySelectorAll('[data-mgr-video-settings-menu]'), function (menu) {
      if (!player || !player.contains(menu)) hideVideoSettingsMenu(menu);
    });
  }

  function hasOpenNativeVideoMenus(player) {
    if (!player) return false;
    var open = false;
    Array.prototype.forEach.call(player.querySelectorAll('[data-mgr-video-settings-menu], [data-mgr-video-select-menu]'), function (menu) {
      if (!menu.hidden) open = true;
    });
    return open;
  }

  function closeNativeVideoMenus(player) {
    if (!player) return;
    player._mgrVideoMenuClosedAt = Date.now();
    var settingsMenu = player.querySelector('[data-mgr-video-settings-menu]');
    if (settingsMenu) {
      hideVideoSettingsMenu(settingsMenu);
    } else {
      Array.prototype.forEach.call(player.querySelectorAll('[data-mgr-video-select-menu]'), function (menu) {
        menu.hidden = true;
      });
    }
  }

  function positionNativeVideoSelectMenu(player, trigger, menu) {
    if (!player || !trigger || !menu) return;

    function position() {
      if (!player || !trigger || !menu || menu.hidden) return;
      var wrap = player.querySelector('[data-mgr-video-settings-wrap]') || player;
      var settingsMenu = player.querySelector('[data-mgr-video-settings-menu]');
      var activeOption = menu.querySelector('.mgr-video-option.is-active') || menu.querySelector('.mgr-video-option');
      if (!activeOption || !wrap.getBoundingClientRect) return;

      var wrapRect = wrap.getBoundingClientRect();
      var triggerRect = trigger.getBoundingClientRect();
      var menuRect = menu.getBoundingClientRect();
      var activeRect = activeOption.getBoundingClientRect();
      var activeCenterInMenu = (activeRect.top - menuRect.top) + (activeRect.height / 2);
      var triggerCenterInWrap = (triggerRect.top - wrapRect.top) + (triggerRect.height / 2);
      var top = Math.round(triggerCenterInWrap - activeCenterInMenu);

      // Position the secondary Speed/Quality list beside the black settings
      // popover, not beside the gear button. The menu is an absolute child of
      // the settings wrapper, so calculate the right offset from the visible
      // popover's left edge.
      var rightOffset = wrapRect.width + 8;
      if (settingsMenu && settingsMenu.getBoundingClientRect && !settingsMenu.hidden) {
        var settingsRect = settingsMenu.getBoundingClientRect();
        rightOffset = Math.round((wrapRect.right - settingsRect.left) + 8);
      }

      menu.style.setProperty('top', top + 'px', 'important');
      menu.style.setProperty('bottom', 'auto', 'important');
      menu.style.setProperty('left', 'auto', 'important');
      menu.style.setProperty('right', rightOffset + 'px', 'important');
    }

    position();
    if (window.requestAnimationFrame) window.requestAnimationFrame(position);
  }

  function attachCustomVideoPlayer(player) {
    var video = player.querySelector('[data-mgr-native-video]');
    var playButton = player.querySelector('[data-mgr-video-play]');
    var muteButton = player.querySelector('[data-mgr-video-mute]');
    var volume = player.querySelector('[data-mgr-video-volume]');
    var seek = player.querySelector('[data-mgr-video-seek]');
    var settings = player.querySelector('[data-mgr-video-settings]');
    var settingsMenu = player.querySelector('[data-mgr-video-settings-menu]');
    var fullscreen = player.querySelector('[data-mgr-video-fullscreen]');
    if (!video) return;

    function setMobileControlsVisible(visible) {
      player.classList.toggle('is-controls-visible', !!visible);
    }

    function togglePlay() {
      try {
        if (video.paused) {
          var promise = video.play && video.play();
          if (promise && typeof promise.catch === 'function') promise.catch(function () {});
        } else {
          video.pause();
        }
      } catch (err) {}
      syncCustomVideoControls(player);
    }

    setMobileControlsVisible(false);

    video.addEventListener('click', function (event) {
      if (Date.now() < detailSuppressClickUntil) return;
      event.preventDefault();
      event.stopPropagation();

      if (hasOpenNativeVideoMenus(player)) {
        closeNativeVideoMenus(player);
        if (isSmallDetailViewport()) setMobileControlsVisible(true);
        return;
      }

      if (player._mgrVideoMenuClosedAt && Date.now() - player._mgrVideoMenuClosedAt < 220) return;

      if (isSmallDetailViewport()) {
        setMobileControlsVisible(!player.classList.contains('is-controls-visible'));
        return;
      }

      togglePlay();
    });

    if (playButton) {
      playButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setMobileControlsVisible(true);
        togglePlay();
      });
    }

    if (muteButton) {
      var lastMuteToggleAt = 0;

      function toggleMuteFromUser(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        setMobileControlsVisible(true);

        if (video.muted || video.volume <= 0) {
          var lastVolume = parseFloat(player.getAttribute('data-mgr-last-volume') || '1');
          if (!isFinite(lastVolume) || lastVolume <= 0) lastVolume = 1;
          lastVolume = Math.max(0.01, Math.min(1, lastVolume));
          player.setAttribute('data-mgr-last-volume', String(lastVolume));
          forceNativeVideoUnmuted(video, lastVolume);
          if (!video.paused && video.play) {
            var keepPlaying = video.play();
            if (keepPlaying && typeof keepPlaying.catch === 'function') keepPlaying.catch(function () {});
          }
          [40, 120, 260, 520].forEach(function (delay) {
            window.setTimeout(function () {
              forceNativeVideoUnmuted(video, lastVolume);
              syncCustomVideoControls(player);
            }, delay);
          });
        } else {
          player.setAttribute('data-mgr-last-volume', String(video.volume || 1));
          forceNativeVideoMuted(video);
        }

        lastMuteToggleAt = Date.now();
        syncCustomVideoControls(player);
        window.setTimeout(function () { syncCustomVideoControls(player); }, 60);
        window.setTimeout(function () { syncCustomVideoControls(player); }, 160);
      }

      muteButton.addEventListener('pointerdown', function (event) {
        toggleMuteFromUser(event);
      });

      muteButton.addEventListener('click', function (event) {
        if (Date.now() - lastMuteToggleAt < 500) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        toggleMuteFromUser(event);
      });
    }

    if (volume) {
      volume.addEventListener('input', function (event) {
        event.stopPropagation();
        setMobileControlsVisible(true);
        var nextVolume = parseFloat(volume.value || '0');
        nextVolume = Math.max(0, Math.min(1, isFinite(nextVolume) ? nextVolume : 0));
        video.volume = nextVolume;
        setNativeVideoMuted(video, nextVolume <= 0);
        if (nextVolume > 0) player.setAttribute('data-mgr-last-volume', String(nextVolume));
        syncCustomVideoControls(player);
      });
      volume.addEventListener('click', function (event) { event.stopPropagation(); });
      volume.addEventListener('pointerdown', function (event) { event.stopPropagation(); });
    }

    if (seek) {
      seek.addEventListener('input', function (event) {
        event.stopPropagation();
        setMobileControlsVisible(true);
        var duration = isFinite(video.duration) && video.duration > 0 ? video.duration : 0;
        if (duration) video.currentTime = (parseFloat(seek.value || '0') / 1000) * duration;
        syncCustomVideoControls(player);
      });
      seek.addEventListener('click', function (event) { event.stopPropagation(); });
      seek.addEventListener('pointerdown', function (event) { event.stopPropagation(); });
    }

    if (settings && settingsMenu) {
      settings.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setMobileControlsVisible(true);
        var willOpen = settingsMenu.hidden;
        closeOtherDetailVideoMenus(player);
        settingsMenu.hidden = !willOpen;
        player.classList.toggle('is-settings-open', willOpen);
        settings.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        Array.prototype.forEach.call(player.querySelectorAll('[data-mgr-video-select-menu]'), function (selectMenu) {
          selectMenu.hidden = true;
        });
      });

      settingsMenu.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setMobileControlsVisible(true);

        var trigger = event.target.closest('[data-mgr-video-setting-select]');
        if (trigger) {
          var targetName = trigger.getAttribute('data-mgr-video-setting-select');
          if (targetName === 'quality') renderNativeVideoQualityMenu(player);
          var targetMenu = player.querySelector('[data-mgr-video-select-menu="' + targetName + '"]');
          var shouldOpen = !targetMenu || targetMenu.hidden;
          Array.prototype.forEach.call(player.querySelectorAll('[data-mgr-video-select-menu]'), function (selectMenu) {
            selectMenu.hidden = true;
          });
          Array.prototype.forEach.call(player.querySelectorAll('[data-mgr-video-setting-select]'), function (row) {
            row.setAttribute('aria-expanded', 'false');
          });
          if (targetMenu) {
            targetMenu.hidden = !shouldOpen;
            trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
            if (shouldOpen) positionNativeVideoSelectMenu(player, trigger, targetMenu);
          }
          return;
        }
      });

      Array.prototype.forEach.call(player.querySelectorAll('[data-mgr-video-select-menu]'), function (selectMenu) {
        selectMenu.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          setMobileControlsVisible(true);

          var speedButton = event.target.closest('[data-mgr-video-speed]');
          var qualityButton = event.target.closest('[data-mgr-video-quality]');

          if (speedButton) {
            var rate = parseFloat(speedButton.getAttribute('data-mgr-video-speed') || '1');
            video.playbackRate = rate || 1;
            Array.prototype.forEach.call(player.querySelectorAll('[data-mgr-video-speed]'), function (button) {
              button.classList.toggle('is-active', button === speedButton);
              button.setAttribute('aria-selected', button === speedButton ? 'true' : 'false');
            });
            selectMenu.hidden = true;
            var speedTrigger = player.querySelector('[data-mgr-video-setting-select="speed"]');
            if (speedTrigger) speedTrigger.setAttribute('aria-expanded', 'false');
            syncCustomVideoControls(player);
            return;
          }

          if (qualityButton) {
            var quality = qualityButton.getAttribute('data-mgr-video-quality') || 'auto';
            player.setAttribute('data-mgr-video-quality', quality);
            setNativeVideoSourceForQuality(player, video, quality);
            Array.prototype.forEach.call(player.querySelectorAll('[data-mgr-video-quality]'), function (button) {
              button.classList.toggle('is-active', button === qualityButton);
              button.setAttribute('aria-selected', button === qualityButton ? 'true' : 'false');
            });
            selectMenu.hidden = true;
            var qualityTrigger = player.querySelector('[data-mgr-video-setting-select="quality"]');
            if (qualityTrigger) qualityTrigger.setAttribute('aria-expanded', 'false');
            syncCustomVideoControls(player);
            return;
          }
        });
      });
    }

    if (fullscreen) {
      fullscreen.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setMobileControlsVisible(true);
        var target = player;
        try {
          if (document.fullscreenElement && document.exitFullscreen) {
            document.exitFullscreen();
          } else if (target.requestFullscreen) {
            target.requestFullscreen();
          } else if (video.webkitEnterFullscreen) {
            video.webkitEnterFullscreen();
          }
        } catch (err) {}
      });
    }

    ['loadedmetadata', 'durationchange', 'timeupdate', 'play', 'pause', 'volumechange', 'ratechange', 'ended'].forEach(function (eventName) {
      video.addEventListener(eventName, function () {
        if (eventName === 'loadedmetadata' || eventName === 'durationchange') renderNativeVideoQualityMenu(player);
        if (eventName === 'ended') {
          // When playback finishes, keep the Loox-style controls visible so
          // the customer can immediately replay, scrub, unmute, or fullscreen.
          setMobileControlsVisible(true);
        }
        syncCustomVideoControls(player);
      });
    });

    player.addEventListener('pointerdown', function (event) {
      if (!hasOpenNativeVideoMenus(player)) return;
      if (event.target.closest('[data-mgr-video-settings-wrap]')) return;
      closeNativeVideoMenus(player);
      if (isSmallDetailViewport()) setMobileControlsVisible(true);
    }, true);

    player.addEventListener('click', function (event) {
      if (event.target.closest('[data-mgr-video-controls], [data-mgr-video-settings-menu], [data-mgr-video-select-menu]')) event.stopPropagation();
    });

    setDetailVideoButton(playButton, 'play', 'Play');
    setDetailVideoButton(muteButton, 'muted', 'Currently muted. Click to unmute.');
    setDetailVideoButton(fullscreen, 'fullscreen', 'Enable Fullscreen');
    if (settings) setDetailVideoButton(settings, 'settings', 'Settings');
    renderNativeVideoQualityMenu(player);
    syncCustomVideoControls(player);
  }

  function buildNativeDetailVideoPlayer(item, autoplay) {
    var player = document.createElement('div');
    player.className = 'mgr-review-detail__native-player';
    player.setAttribute('data-mgr-native-player', '');
    player.setAttribute('data-mgr-last-volume', '1');
    player.setAttribute('data-mgr-video-quality', 'auto');
    player._mgrVideoSources = Array.isArray(item.sources) ? item.sources : [];
    player._mgrVideoDeclaredQualities = Array.isArray(item.qualities) ? item.qualities : [];
    player._mgrVideoAutoUrl = item.url || (player._mgrVideoSources.length ? player._mgrVideoSources[0].url : '');

    var video = document.createElement('video');
    video.className = 'mgr-review-detail__video';
    video.playsInline = true;
    video.preload = 'metadata';
    video.muted = true;
    video.autoplay = !!autoplay;
    video.controls = false;
    video.setAttribute('data-mgr-native-video', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('muted', '');
    video.setAttribute('preload', 'metadata');
    video.setAttribute('aria-label', item.alt || t('customerReviewPhoto'));
    video.addEventListener('loadedmetadata', function () {
      applyDetailDynamicMediaSizing();
    });
    if (item.poster) video.poster = item.poster;
    if (item.url) video.src = (isIOSLikeDevice() && !item.poster && !autoplay) ? getFirstFrameVideoUrl(item.url) : item.url;
    else if (player._mgrVideoAutoUrl) video.src = (isIOSLikeDevice() && !item.poster && !autoplay) ? getFirstFrameVideoUrl(player._mgrVideoAutoUrl) : player._mgrVideoAutoUrl;

    var controls = document.createElement('div');
    controls.className = 'mgr-video-controls css-7zn2r1 css-ak9s4m css-sanqhm';
    controls.setAttribute('data-mgr-video-controls', '');
    controls.innerHTML = [
      '<div class="mgr-video-progress-row css-16427om css-1oxfqe2 css-1yhz3r0">',
        '<div class="mgr-video-seek-wrap css-1dfsi8o">',
          '<input class="mgr-video-seek css-1y1nrlo" data-mgr-video-seek aria-label="seek slider" role="slider" type="range" min="0" max="1000" step="1" value="0">',
        '</div>',
        '<div class="mgr-video-time css-1v8tq7l" data-mgr-video-time>0:00 / 0:00</div>',
      '</div>',
      '<div class="mgr-video-buttons css-6mrf8j css-1oxfqe2">',
        '<button class="mgr-video-control-button css-15yzd3w css-yz8w9z" type="button" data-mgr-video-play aria-label="Play"></button>',
        '<div class="mgr-video-volume css-awah88">',
          '<button class="mgr-video-control-button css-15yzd3w css-yz8w9z css-1sgkk9b" type="button" data-mgr-video-mute aria-label="Mute"></button>',
          '<input class="mgr-video-volume-slider css-9ibc3t" data-mgr-video-volume name="volume" aria-label="volume" type="range" min="0" max="1" step=".01" value="0">',
        '</div>',
        '<div class="mgr-video-spacer css-1ypjkz1"></div>',
        '<div class="mgr-video-settings-wrap" data-mgr-video-settings-wrap>',
          '<button class="mgr-video-control-button css-15yzd3w css-nd675r" type="button" aria-haspopup="dialog" aria-expanded="false" data-mgr-video-settings></button>',
          '<div class="mgr-video-settings-menu" data-mgr-video-settings-menu hidden role="dialog">',
            '<span class="mgr-video-settings-arrow" aria-hidden="true"></span>',
            '<button type="button" class="mgr-video-settings-row" data-mgr-video-setting-select="speed" role="combobox" aria-expanded="false"><span class="' + translatedClass('mgr-video-settings-label') + '"' + translatedAttr() + '>' + getVideoUiLabel('speedLabel') + '</span><strong class="notranslate gtranslate-no-translate gt-skip" translate="no" data-mgr-video-speed-value>1x</strong></button>',
            '<button type="button" class="mgr-video-settings-row" data-mgr-video-setting-select="quality" role="combobox" aria-expanded="false"><span class="' + translatedClass('mgr-video-settings-label') + '"' + translatedAttr() + '>' + getVideoUiLabel('qualityLabel') + '</span><strong class="notranslate gtranslate-no-translate gt-skip" translate="no" data-mgr-video-quality-value>auto</strong></button>',
          '</div>',
          '<div class="mgr-video-select-menu mgr-video-select-menu--speed notranslate gtranslate-no-translate gt-skip" translate="no" data-mgr-video-select-menu="speed" role="listbox" hidden>',
            '<button type="button" class="mgr-video-option" data-mgr-video-speed="0.25" role="option" aria-selected="false"><span class="mgr-video-option-check" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor" aria-hidden="true" focusable="false"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7l233.4-233.3c12.5-12.5 32.8-12.5 45.3 0z"></path></svg></span><span class="notranslate gtranslate-no-translate gt-skip" translate="no">0.25x</span></button>',
            '<button type="button" class="mgr-video-option" data-mgr-video-speed="0.5" role="option" aria-selected="false"><span class="mgr-video-option-check" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor" aria-hidden="true" focusable="false"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7l233.4-233.3c12.5-12.5 32.8-12.5 45.3 0z"></path></svg></span><span class="notranslate gtranslate-no-translate gt-skip" translate="no">0.5x</span></button>',
            '<button type="button" class="mgr-video-option" data-mgr-video-speed="0.75" role="option" aria-selected="false"><span class="mgr-video-option-check" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor" aria-hidden="true" focusable="false"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7l233.4-233.3c12.5-12.5 32.8-12.5 45.3 0z"></path></svg></span><span class="notranslate gtranslate-no-translate gt-skip" translate="no">0.75x</span></button>',
            '<button type="button" class="mgr-video-option is-active" data-mgr-video-speed="1" role="option" aria-selected="true"><span class="mgr-video-option-check" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor" aria-hidden="true" focusable="false"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7l233.4-233.3c12.5-12.5 32.8-12.5 45.3 0z"></path></svg></span><span class="notranslate gtranslate-no-translate gt-skip" translate="no">1x</span></button>',
            '<button type="button" class="mgr-video-option" data-mgr-video-speed="1.25" role="option" aria-selected="false"><span class="mgr-video-option-check" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor" aria-hidden="true" focusable="false"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7l233.4-233.3c12.5-12.5 32.8-12.5 45.3 0z"></path></svg></span><span class="notranslate gtranslate-no-translate gt-skip" translate="no">1.25x</span></button>',
            '<button type="button" class="mgr-video-option" data-mgr-video-speed="1.5" role="option" aria-selected="false"><span class="mgr-video-option-check" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor" aria-hidden="true" focusable="false"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7l233.4-233.3c12.5-12.5 32.8-12.5 45.3 0z"></path></svg></span><span class="notranslate gtranslate-no-translate gt-skip" translate="no">1.5x</span></button>',
            '<button type="button" class="mgr-video-option" data-mgr-video-speed="1.75" role="option" aria-selected="false"><span class="mgr-video-option-check" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor" aria-hidden="true" focusable="false"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7l233.4-233.3c12.5-12.5 32.8-12.5 45.3 0z"></path></svg></span><span class="notranslate gtranslate-no-translate gt-skip" translate="no">1.75x</span></button>',
            '<button type="button" class="mgr-video-option" data-mgr-video-speed="2" role="option" aria-selected="false"><span class="mgr-video-option-check" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor" aria-hidden="true" focusable="false"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7l233.4-233.3c12.5-12.5 32.8-12.5 45.3 0z"></path></svg></span><span class="notranslate gtranslate-no-translate gt-skip" translate="no">2x</span></button>',
          '</div>',          '<div class="mgr-video-select-menu mgr-video-select-menu--quality notranslate gtranslate-no-translate gt-skip" translate="no" data-mgr-video-select-menu="quality" role="listbox" hidden>',
            '<button type="button" class="mgr-video-option is-active" data-mgr-video-quality="auto" role="option" aria-selected="true"><span class="mgr-video-option-check" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor" aria-hidden="true" focusable="false"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7l233.4-233.3c12.5-12.5 32.8-12.5 45.3 0z"></path></svg></span><span class="notranslate gtranslate-no-translate gt-skip" translate="no">auto</span></button>',
          '</div>',
        '</div>',
        '<button class="mgr-video-control-button css-15yzd3w css-yz8w9z" type="button" data-mgr-video-fullscreen aria-label="Enable Fullscreen"></button>',
      '</div>'
    ].join('');

    player.appendChild(video);
    player.appendChild(controls);
    attachCustomVideoPlayer(player);
    return player;
  }

  function renderDetailVideoIntoHost(host, item, autoplay) {
    if (!host || !item) return;
    host.innerHTML = '';

    if (item.streamId) {
      ensureCloudflareStreamSdk(item.streamId, item.customerDomain);
      var stream = document.createElement('stream');
      stream.className = 'mgr-review-detail__stream';
      stream.setAttribute('width', '100%');
      stream.setAttribute('height', '100%');
      stream.setAttribute('src', item.streamId);
      if (autoplay) stream.setAttribute('autoplay', '');
      stream.setAttribute('preload', 'auto');
      stream.setAttribute('controls', '');
      stream.setAttribute('muted', '');
      stream.setAttribute('playsinline', '');
      stream.setAttribute('style', 'width: 100%; height: 100%;');
      if (item.customerDomain) stream.setAttribute('customer-domain-prefix', item.customerDomain);
      if (item.poster) stream.setAttribute('poster', item.poster);
      host.appendChild(stream);
      window.setTimeout(applyDetailDynamicMediaSizing, 60);
      return;
    }

    if (item.embedUrl) {
      var iframe = document.createElement('iframe');
      iframe.className = 'mgr-review-detail__video-iframe';
      iframe.src = item.embedUrl;
      iframe.title = item.alt || t('customerReviewPhoto');
      iframe.loading = 'lazy';
      iframe.allow = 'accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.setAttribute('allowfullscreen', '');
      host.appendChild(iframe);
      window.setTimeout(applyDetailDynamicMediaSizing, 60);
      return;
    }

    host.appendChild(buildNativeDetailVideoPlayer(item, autoplay));
  }

  function renderDetailMediaTrack() {
    if (!detailModalElement) return;
    var track = getDetailTrack();
    if (!track) return;
    var signature = getDetailTrackSignature();
    if (detailTrackRenderedSignature === signature && track.children.length === currentDetailImages.length) {
      return;
    }

    pauseAllDetailNativeVideos();
    track.innerHTML = '';
    detailTrackRenderedSignature = signature;

    currentDetailImages.forEach(function (item, index) {
      var slide = document.createElement('div');
      slide.className = 'mgr-review-detail__slide';
      slide.setAttribute('data-mgr-detail-slide', String(index));
      slide.setAttribute('aria-hidden', index === currentDetailImageIndex ? 'false' : 'true');

      if (item && item.type === 'video') {
        slide.className += ' mgr-review-detail__slide--video';
        var host = document.createElement('div');
        host.className = 'mgr-review-detail__video-host';
        host.setAttribute('data-mgr-detail-video-host', '');
        renderDetailVideoIntoHost(host, item, index === currentDetailImageIndex);
        slide.appendChild(host);
      } else if (item) {
        var image = document.createElement('img');
        image.id = index === 0 ? 'mgr-review-detail-image' : '';
        image.className = 'mgr-review-detail__image';
        image.setAttribute('data-mgr-detail-image', '');
        image.src = item.url;
        image.alt = item.alt || t('customerReviewPhoto');
        image.decoding = 'async';
        image.draggable = false;
        image.setAttribute('draggable', 'false');
        image.addEventListener('load', function () {
          applyDetailDynamicMediaSizing();
        });
        if (image.complete && image.naturalWidth) {
          window.setTimeout(applyDetailDynamicMediaSizing, 0);
        }
        slide.appendChild(image);
      }
      track.appendChild(slide);
    });

    setDetailTrackPosition(0, false);
  }

  function markActiveDetailSlide() {
    if (!detailModalElement) return;
    Array.prototype.forEach.call(detailModalElement.querySelectorAll('[data-mgr-detail-slide]'), function (slide, index) {
      var isActive = index === currentDetailImageIndex;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      if (!isActive) {
        var video = slide.querySelector('[data-mgr-native-video]');
        if (video && typeof video.pause === 'function') {
          try { video.pause(); } catch (err) {}
        }
      }
    });
  }

  function pauseDetailVideo() {
    pauseAllDetailNativeVideos();
  }

  function stopDetailVideo() {
    pauseAllDetailNativeVideos();
    if (!detailModalElement) return;
    var track = getDetailTrack();
    if (track) track.innerHTML = '';
    detailTrackRenderedSignature = '';
  }

  function renderDetailVideo(item) {
    renderDetailMediaTrack();
  }

  function showDetailImage(index) {
    if (!detailModalElement || !currentDetailImages.length) return;

    var previousIndex = currentDetailImageIndex;
    if (index < 0) index = 0;
    if (index >= currentDetailImages.length) index = currentDetailImages.length - 1;

    currentDetailImageIndex = index;
    var item = currentDetailImages[index];
    var imageWrap = detailModalElement.querySelector('[data-mgr-detail-image-wrap]');

    renderDetailMediaTrack();
    markActiveDetailSlide();

    if (imageWrap) {
      imageWrap.classList.toggle('mgr-review-detail__image-wrap--video', !!(item && item.type === 'video'));
    }

    // Keep the attached-slide movement visible. Dynamic media sizing also
    // repositions the track, so do the slide transform first and only resize
    // after the transition has had a chance to run. Otherwise the track jumps
    // directly to the new slide with transition:none and the swipe/arrow
    // movement looks broken.
    var shouldAnimateSlide = previousIndex !== index;
    setDetailTrackPosition(0, shouldAnimateSlide);
    window.setTimeout(applyDetailDynamicMediaSizing, shouldAnimateSlide ? 280 : 0);

    if (item && item.type === 'video') {
      playActiveDetailVideoIfNeeded();
    } else {
      pauseAllDetailNativeVideos();
      closeOtherDetailVideoMenus();
    }

    updateDetailSliderControls();
  }

  function clearDetailSlider() {
    currentDetailImages = [];
    currentDetailImageIndex = 0;
    clearDetailDynamicMediaSizing();
    if (!detailModalElement) return;
    stopDetailVideo();
    var imageWrap = detailModalElement.querySelector('[data-mgr-detail-image-wrap]');
    if (imageWrap) imageWrap.classList.remove('mgr-review-detail__image-wrap--video');

    var thumbs = detailModalElement.querySelector('[data-mgr-detail-thumbs]');
    if (thumbs) {
      thumbs.innerHTML = '';
      thumbs.hidden = true;
    }
    updateDetailSliderControls();
  }

  function setText(element, text) {
    if (!element) return;
    element.textContent = text || '';
  }

  function openReviewDetailModal(review, baseUrl, sourceCard) {
    refreshLanguage();
    if (!review) return;

    if (!detailModalElement) {
      detailModalElement = createReviewDetailModal();
    }

    lastDetailFocusedElement = document.activeElement;

    var imageWrap = detailModalElement.querySelector('[data-mgr-detail-image-wrap]');
    var image = detailModalElement.querySelector('[data-mgr-detail-image]');
    var name = detailModalElement.querySelector('.mgr-review-detail__name');
    var stars = detailModalElement.querySelector('.mgr-review-detail__stars');
    var verified = detailModalElement.querySelector('.mgr-review-detail__verified-wrap');
    var date = detailModalElement.querySelector('.mgr-review-detail__date');
    var text = detailModalElement.querySelector('.mgr-review-detail__text');
    var extra = detailModalElement.querySelector('.mgr-review-detail__extra');
    var product = detailModalElement.querySelector('.mgr-review-detail__product');
    var productImage = detailModalElement.querySelector('[data-mgr-detail-product-image]');
    var productName = detailModalElement.querySelector('.mgr-review-detail__product-name');
    var productLink = detailModalElement.querySelector('.mgr-review-detail__product-link');

    currentDetailImages = getReviewImages(review, baseUrl);
    currentDetailImageIndex = 0;
    detailTrackRenderedSignature = '';
    if (currentDetailImages.length && imageWrap) {
      imageWrap.hidden = false;
      detailModalElement.classList.remove('mgr-review-detail-modal--no-image');
      renderDetailSliderThumbs();
      showDetailImage(0);
    } else if (imageWrap) {
      if (image) image.removeAttribute('src');
      imageWrap.hidden = true;
      detailModalElement.classList.add('mgr-review-detail-modal--no-image');
      clearDetailSlider();
    }

    setLocalizedText(name, getReviewField(review, 'name', t('verifiedCustomer')), hasReviewTranslation(review, 'name'));

    if (stars) {
      stars.setAttribute('aria-label', t('outOfFiveStars').replace('{rating}', normalizeStars(review.rating)));
      appendSvgStars(stars, review.rating);
    }

    if (verified) {
      verified.hidden = review.verified === false;
    }

    closeVerifyPopover();
    closeVerifySheet();

    if (date) {
      var dateText = review.date || review.review_date || '';
      date.hidden = !dateText;
      date.textContent = dateText;
    }

    setLocalizedText(text, getReviewField(review, 'text', ''), hasReviewTranslation(review, 'text'));

    if (extra) {
      extra.innerHTML = '';
      extra.hidden = true;
    }

    var productUrl = resolveProductUrl(review) || review._resolved_product_url || (sourceCard && sourceCard.getAttribute('data-product-url')) || '';
    var productThumbSource = review.product_thumb || (productUrl ? 'mexicada-review-thumb.svg' : '');
    var productThumbUrl = resolveAssetUrl(productThumbSource, baseUrl);
    if (detailModalElement) {
      detailModalElement.setAttribute('data-current-product-url', productUrl || '');
    }

    var localizedDetailProductName = getReviewField(review, 'product_name', '');

    if (product && (localizedDetailProductName || productThumbUrl || productUrl)) {
      product.hidden = false;
      if (productImage) {
        if (productThumbUrl) {
          productImage.src = productThumbUrl;
          productImage.alt = localizedDetailProductName || t('reviewedProduct');
          productImage.hidden = false;
          applyProductGalleryImage(productImage, productUrl, 400);
        } else {
          productImage.hidden = true;
          productImage.removeAttribute('src');
        }
      }

      setLocalizedText(productName, localizedDetailProductName || t('reviewedProduct'), hasReviewTranslation(review, 'product_name'));

      if (productLink) {
        if (productUrl) {
          productLink.href = productUrl;
          productLink.target = '_blank';
          productLink.rel = 'noopener noreferrer';
          productLink.hidden = false;
          productLink.removeAttribute('hidden');
          productLink.removeAttribute('aria-hidden');
          productLink.style.removeProperty('display');
          productLink.setAttribute('data-product-url', productUrl);
        } else {
          productLink.hidden = true;
          productLink.setAttribute('hidden', '');
          productLink.setAttribute('aria-hidden', 'true');
          productLink.removeAttribute('href');
          productLink.removeAttribute('target');
          productLink.removeAttribute('rel');
          productLink.removeAttribute('data-product-url');
        }
      }
    } else if (product) {
      product.hidden = true;
    }

    lockDetailPageScroll();

    if (detailCloseTimer) {
      window.clearTimeout(detailCloseTimer);
      detailCloseTimer = null;
    }
    if (detailAnimationFrame) {
      window.cancelAnimationFrame(detailAnimationFrame);
      detailAnimationFrame = null;
    }

    detailModalElement.classList.remove('is-closing', 'is-open');
    detailModalElement.hidden = false;
    applyDetailDynamicMediaSizing();
    window.setTimeout(applyDetailDynamicMediaSizing, 60);
    // Force a reflow so the starting (scaled-down, transparent) state is
    // committed before we add is-open, otherwise the browser skips the
    // transition and the modal just pops in.
    void detailModalElement.offsetWidth;
    detailAnimationFrame = window.requestAnimationFrame(function () {
      detailAnimationFrame = null;
      detailModalElement.classList.add('is-open');
    });

    var panel = detailModalElement.querySelector('.mgr-review-detail__panel');
    if (panel && typeof panel.focus === 'function') {
      try {
        panel.focus({ preventScroll: true });
      } catch (err) {
        // Avoid fallback focus without preventScroll because it can move the page.
      }
    }
    restoreDetailScrollPosition();
  }

  function findReviewCardTarget(target) {
    if (!target) return null;
    if (target.nodeType !== 1) target = target.parentElement;
    if (!target || typeof target.closest !== 'function') return null;
    var card = target.closest('.mgr-card');
    if (!card) return null;
    if (target.closest('.mgr-review-detail-modal')) return null;
    return reviewDataByCard.has(card) ? card : null;
  }

  function bindReviewCardDetailTrigger() {
    document.addEventListener('click', function (event) {
      var card = findReviewCardTarget(event.target);
      if (!card) return;
      event.preventDefault();
      var data = reviewDataByCard.get(card);
      openReviewDetailModal(data.review, data.baseUrl, card);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var card = findReviewCardTarget(event.target);
      if (!card) return;
      event.preventDefault();
      var data = reviewDataByCard.get(card);
      openReviewDetailModal(data.review, data.baseUrl, card);
    });
  }

  function prepareTrustBanners() {
    document.querySelectorAll(REVIEW_MODAL_TRIGGER_SELECTOR).forEach(function (banner) {
      if (banner.getAttribute('data-mgr-reviews-trigger-ready') === 'true') return;
      banner.setAttribute('data-mgr-reviews-trigger-ready', 'true');
      banner.setAttribute('tabindex', banner.getAttribute('tabindex') || '0');
      banner.setAttribute('role', 'button');
      banner.setAttribute('aria-label', 'Open customer reviews');
    });
  }

  function findTrustBannerTarget(target) {
    if (!target) return null;
    if (target.nodeType !== 1) target = target.parentElement;
    if (!target || typeof target.closest !== 'function') return null;
    if (target.closest(ATC_REVIEW_NAV_SELECTOR)) return null;

    var trigger = target.closest(REVIEW_MODAL_TRIGGER_SELECTOR);
    if (!trigger) return null;

    if (trigger.matches && trigger.matches('h2.site-footer-block-title')) {
      var label = trigger.querySelector('.notranslate');
      var labelText = label ? (label.textContent || '').replace(/\s+/g, ' ').trim() : '';
      var triggerText = (trigger.textContent || '').replace(/\s+/g, ' ').trim();
      if (labelText.indexOf('Join 97,000+ Insiders') === -1 && triggerText.indexOf('Join 97,000+ Insiders') === -1) return null;
    }

    return trigger;
  }

  function bindTrustBannerTrigger() {
    if (trustBannerListenersBound) return;
    trustBannerListenersBound = true;

    document.addEventListener('click', function (event) {
      var banner = findTrustBannerTarget(event.target);
      if (!banner) return;
      event.preventDefault();
      event.stopPropagation();
      openReviewsModal();
    }, true);

    document.addEventListener('keydown', function (event) {
      var banner = findTrustBannerTarget(event.target);
      if (!banner) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      openReviewsModal();
    }, true);
  }


  function getCompactGlobalReviewCountText() {
    return getDynamicReviewCountValue() || '14,764';
  }

  function renderCompactFiveStars() {
    var star = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" style="width:16px;height:16px;vertical-align:middle;flex:0 0 auto;"><path fill="#1a1a1a" d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.27 5.82 22 7 14.14l-5-4.87 6.91-1.01z"></path></svg>';
    return '<span class="pack-review-stars" style="display:inline-flex;gap:1px;vertical-align:middle;margin-right:5px;" aria-hidden="true">' + star + star + star + star + star + '</span>';
  }

  function renderCompactProductReviewSummaryHtml() {
    var count = getCompactGlobalReviewCountText();
    return renderCompactFiveStars() +
      '<span class="mexicada-product-review-summary__count notranslate gtranslate-no-translate gt-skip" translate="no" style="display:inline-flex;align-items:center;white-space:nowrap;margin-left:0;margin-right:0;line-height:1.15;color:#1a1a1a !important;">(<span class="notranslate gtranslate-no-translate gt-skip" translate="no">' + escapeHtml(count) + '</span>)</span>';
  }

  function isProductReviewSummaryNormalized(target) {
    if (!target || !target.querySelector) return false;
    return target.getAttribute('data-mgr-product-summary-normalized') === 'true' &&
      !!target.querySelector('.mexicada-product-review-summary__count') &&
      !target.querySelector('.evm-reviews-widget') &&
      (target.textContent || '').indexOf('ratings') === -1 &&
      (target.textContent || '').indexOf('reviews') === -1;
  }

  function normalizeProductReviewSummaries(root) {
    root = root || document;
    var nodes = [];
    root.querySelectorAll('.product-review-wrapper-under-breadcrumbs a.store-reviews, .product-review-wrapper-under-breadcrumbs .store-reviews, .mexicada-product-review-summary').forEach(function (node) {
      if (nodes.indexOf(node) === -1) nodes.push(node);
    });

    nodes.forEach(function (node) {
      var target = node;
      if (node.classList && node.classList.contains('store-reviews') && node.tagName !== 'A') {
        var parentAnchor = node.closest && node.closest('a');
        if (parentAnchor && parentAnchor.parentNode && parentAnchor.querySelector('.store-reviews') === node) {
          target = parentAnchor;
        }
      }

      if (!target || !target.setAttribute || isProductReviewSummaryNormalized(target)) return;
      target.setAttribute('href', '#mexicada-global-reviews-modal');
      target.setAttribute('role', 'button');
      target.setAttribute('aria-label', 'Open customer reviews');
      target.setAttribute('data-mgr-product-review-summary-trigger', '');
      target.setAttribute('data-mgr-product-summary-normalized', 'true');
      target.setAttribute('translate', 'no');
      if (target.classList) {
        target.classList.add('store-reviews', 'review-scroll-link', 'mexicada-product-review-summary', 'notranslate', 'gtranslate-no-translate', 'gt-skip');
      }
      target.style.display = 'flex';
      target.style.alignItems = 'center';
      target.style.lineHeight = '1.15';
      target.style.textDecoration = 'none';
      target.style.color = 'inherit';
      target.innerHTML = renderCompactProductReviewSummaryHtml();
    });
  }

  var productReviewSummaryObserverStarted = false;
  function watchProductReviewSummaries() {
    if (productReviewSummaryObserverStarted || !window.MutationObserver) return;
    var wrapper = document.querySelector('.product-review-wrapper-under-breadcrumbs');
    if (!wrapper) return;
    productReviewSummaryObserverStarted = true;
    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        normalizeProductReviewSummaries(document);
        prepareTrustBanners();
      });
    });
    observer.observe(wrapper, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 15000);
  }


  function initAll() {
    updateStaticReviewCopy(document);
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
    normalizeProductReviewSummaries(document);
    prepareTrustBanners();
    watchProductReviewSummaries();
  }

  ready(function () {
    initAll();
    window.setTimeout(function () { updateStaticReviewCopy(document); normalizeProductReviewSummaries(document); prepareTrustBanners(); }, 250);
    window.setTimeout(function () { updateStaticReviewCopy(document); normalizeProductReviewSummaries(document); prepareTrustBanners(); }, 1000);
    window.setTimeout(function () { normalizeProductReviewSummaries(document); prepareTrustBanners(); }, 2500);
    bindTrustBannerTrigger();
    bindReviewCardDetailTrigger();
  });

  window.addEventListener('resize', function () {
    if (detailModalElement && !detailModalElement.hidden && currentDetailImages.length) {
      applyDetailDynamicMediaSizing();
      setDetailTrackPosition(0, false);
    }
  });

  window.addEventListener('orientationchange', function () {
    window.setTimeout(function () {
      if (detailModalElement && !detailModalElement.hidden && currentDetailImages.length) {
        applyDetailDynamicMediaSizing();
        setDetailTrackPosition(0, false);
      }
    }, 120);
  });

  document.addEventListener('shopify:section:load', initAll);
})();